/* ═══ EUROLATINA ORÇAMENTO TÉCNICO v9 ═══ */
/* 5 abas: Orçamento | Corrosividade | Comparativo | ROI | Piso Industrial */
/* v9: Fix cart null variants, scroll arrows genérico, terminologia "Padrão do Mercado" */
/* Totalmente escopado sob #el-ot. Não afeta nenhum outro script do tema. */
(function(){
'use strict';

/* ─── RAL HEX MAP ─── */
const RAL_HEX={
  '1001':'#BEAA5E','1002':'#C2B078','1003':'#E5BE01','1004':'#CDA434','1005':'#A98307',
  '1006':'#E4A010','1007':'#DC9D00','1011':'#8A6642','1012':'#C7B446','1013':'#EAE6CA',
  '1014':'#E1CC4F','1015':'#E6D690','1016':'#EDFF21','1017':'#F5D033','1018':'#F8F32B',
  '1019':'#9E9764','1020':'#999950','1021':'#F3DA0B','1023':'#FAD201','1024':'#AEA04B',
  '1027':'#9D9101','1028':'#F4A900','1032':'#D6AE01','1033':'#F3A505','1034':'#EFA94A',
  '1035':'#6A5D4D','1036':'#705335','1037':'#F39F18',
  '2000':'#ED760E','2001':'#C93C20','2002':'#CB2821','2003':'#FF7514','2004':'#F44611',
  '2005':'#FF2301','2008':'#F75E25','2009':'#F54021','2010':'#D84B20','2011':'#EC7C26',
  '2012':'#E55137','2013':'#C35831',
  '3000':'#AF2B1E','3001':'#A52019','3002':'#A2231D','3003':'#9B111E','3004':'#75151E',
  '3005':'#5E2129','3007':'#412227','3009':'#642424','3011':'#781F19','3012':'#C1876B',
  '3013':'#A12312','3014':'#D36E70','3015':'#EA899A','3016':'#B32821','3017':'#E63244',
  '3018':'#D3545F','3020':'#CC0605','3022':'#D95030','3024':'#F80000','3026':'#FE0000',
  '3027':'#C51D34','3028':'#CB3234','3031':'#B32428','3032':'#721422','3033':'#B44C43',
  '4001':'#6D3461','4002':'#922B3E','4003':'#DE4C8A','4004':'#641C34','4005':'#6C4675',
  '4006':'#A03472','4007':'#4A192C','4008':'#924E7D','4009':'#A18594','4010':'#CF3476',
  '4011':'#8673A1','4012':'#6C6874',
  '5000':'#354D73','5001':'#1F3438','5002':'#20214F','5003':'#1D1E33','5004':'#18171C',
  '5005':'#1E2460','5007':'#3E5F8A','5008':'#26252D','5009':'#025669','5010':'#0E294B',
  '5011':'#231A24','5012':'#3B83BD','5013':'#1E213D','5014':'#606E8C','5015':'#2271B3',
  '5017':'#063971','5018':'#3F888F','5019':'#1B5583','5020':'#1D334A','5021':'#256D7B',
  '5022':'#252850','5023':'#49678D','5024':'#5D9B9B','5025':'#2A6478','5026':'#102C54',
  '6000':'#316650','6001':'#287233','6002':'#2D572C','6003':'#424632','6004':'#1F3A3D',
  '6005':'#2F4538','6006':'#3E3B32','6007':'#343B29','6008':'#39352A','6009':'#31372B',
  '6010':'#35682D','6011':'#587246','6012':'#343E40','6013':'#6C7156','6014':'#47402E',
  '6015':'#3B3C36','6016':'#1E5945','6017':'#4C9141','6018':'#57A639','6019':'#BDECB6',
  '6020':'#2E3A23','6021':'#89AC76','6022':'#25221B','6024':'#308446','6025':'#3D642D',
  '6026':'#015D52','6027':'#84C3BE','6028':'#2C5545','6029':'#20603D','6032':'#317F43',
  '6033':'#497E76','6034':'#7FB5B5','6035':'#1C542D','6036':'#193737','6037':'#008F39',
  '7000':'#78858B','7001':'#8A9597','7002':'#7E7B52','7003':'#6C7059','7004':'#969992',
  '7005':'#646B63','7006':'#6D6552','7008':'#6A5F31','7009':'#4D5645','7010':'#4C514A',
  '7011':'#434B4D','7012':'#4E5754','7013':'#464531','7015':'#434750','7016':'#293133',
  '7021':'#23282B','7022':'#332F2C','7023':'#686C5E','7024':'#474A51','7026':'#2F353B',
  '7030':'#8B8C7A','7031':'#474B4E','7032':'#B8B799','7033':'#7D8471','7034':'#8F8B66',
  '7035':'#D7D7D7','7036':'#7F7679','7037':'#7D7F7D','7038':'#B5B8B1','7039':'#6C6960',
  '7040':'#9DA1AA','7042':'#8D948D','7043':'#4E5452','7044':'#CAC4B0','7045':'#909090',
  '7046':'#82898F','7047':'#D0D0D0','7048':'#898176',
  '8000':'#826C34','8001':'#955F20','8002':'#6C3B2A','8003':'#734222','8004':'#8E402A',
  '8007':'#59351F','8008':'#6F4F28','8011':'#5B3A29','8012':'#592321','8014':'#382C1E',
  '8015':'#633A34','8016':'#4C2F27','8017':'#45322E','8019':'#403A3A','8022':'#212121',
  '8023':'#A65E2E','8024':'#79553D','8025':'#755C48','8028':'#4E3B31','8029':'#763C28',
  '9001':'#FDF4E3','9002':'#E7EBDA','9003':'#F4F4F4','9004':'#282828','9005':'#0A0A0A',
  '9006':'#A5A5A5','9007':'#8F8F8F','9010':'#FFFFFF','9011':'#1C1C1C','9016':'#F6F6F6',
  '9017':'#1E1E1E','9018':'#D7D7D7','9022':'#9C9C9C','9023':'#828282',
  '499':'#808080','501':'#0A0A0A','727':'#FFFFFF','756':'#C0C0C0','758':'#F4F4F4'
};

/* RAL name labels */
const RAL_NAMES={
  '1001':'Beige / Bege','1002':'Sand Yellow / Amarelo Areia','1003':'Signal Yellow / Amarelo Sinal','1004':'Golden Yellow / Amarelo Ouro','1005':'Honey Yellow / Amarelo Mel',
  '1006':'Maize Yellow / Amarelo Milho','1007':'Daffodil Yellow / Amarelo Narciso','1011':'Brown Beige / Bege Marrom','1012':'Lemon Yellow / Amarelo Limão','1013':'Oyster White / Branco Pérola',
  '1014':'Ivory / Marfim','1015':'Light Ivory / Marfim Claro','1016':'Sulfur Yellow / Amarelo Enxofre','1017':'Saffron Yellow / Amarelo Açafrão','1018':'Zinc Yellow / Amarelo Zinco',
  '1019':'Grey Beige / Bege Cinza','1020':'Olive Yellow / Amarelo Oliva','1021':'Colza Yellow / Amarelo Colza','1023':'Traffic Yellow / Amarelo Tráfego','1024':'Ochre Yellow / Amarelo Ocre',
  '1027':'Curry / Curry','1028':'Melon Yellow / Amarelo Melão','1032':'Broom Yellow / Amarelo Giesta','1033':'Dahlia Yellow / Amarelo Dália','1034':'Pastel Yellow / Amarelo Pastel',
  '1035':'Pearl Beige / Bege Pérola','1036':'Pearl Gold / Ouro Pérola','1037':'Sun Yellow / Amarelo Sol',
  '2000':'Yellow Orange / Laranja Amarelo','2001':'Red Orange / Laranja Avermelhado','2002':'Vermilion / Vermelhão','2003':'Pastel Orange / Laranja Pastel','2004':'Pure Orange / Laranja Puro',
  '2005':'Luminous Orange / Laranja Luminoso','2008':'Bright Red Orange / Laranja Brilhante','2009':'Traffic Orange / Laranja Tráfego','2010':'Signal Orange / Laranja Sinal',
  '2011':'Deep Orange / Laranja Intenso','2012':'Salmon Range / Salmão','2013':'Pearl Orange / Laranja Pérola',
  '3000':'Flame Red / Vermelho Chama','3001':'Signal Red / Vermelho Sinal','3002':'Carmine Red / Vermelho Carmim','3003':'Ruby Red / Vermelho Rubi','3004':'Purple Red / Vermelho Púrpura',
  '3005':'Wine Red / Vermelho Vinho','3007':'Black Red / Vermelho Escuro','3009':'Oxide Red / Vermelho Óxido','3011':'Brown Red / Vermelho Marrom','3012':'Beige Red / Vermelho Bege',
  '3013':'Tomato Red / Vermelho Tomate','3014':'Antique Pink / Rosa Antigo','3015':'Light Pink / Rosa Claro','3016':'Coral Red / Vermelho Coral','3017':'Rose / Rosa',
  '3018':'Strawberry Red / Vermelho Morango','3020':'Traffic Red / Vermelho Tráfego','3022':'Salmon Pink / Rosa Salmão','3024':'Luminous Red / Vermelho Luminoso','3026':'Luminous Bright Red / Vermelho Brilhante',
  '3027':'Raspberry Red / Vermelho Framboesa','3028':'Pure Red / Vermelho Puro','3031':'Orient Red / Vermelho Oriental','3032':'Pearl Ruby Red / Rubi Pérola','3033':'Pearl Pink / Rosa Pérola',
  '4001':'Red Lilac / Lilás Vermelho','4002':'Red Violet / Violeta Vermelho','4003':'Heather Violet / Violeta Urze','4004':'Claret Violet / Violeta Bordeaux','4005':'Blue Lilac / Lilás Azul',
  '4006':'Traffic Purple / Púrpura Tráfego','4007':'Purple Violet / Violeta Púrpura','4008':'Signal Violet / Violeta Sinal','4009':'Pastel Violet / Violeta Pastel','4010':'Telemagenta / Telemagenta',
  '4011':'Pearl Violet / Violeta Pérola','4012':'Pearl Blackberry / Amora Pérola',
  '5000':'Violet Blue / Azul Violeta','5001':'Green Blue / Azul Esverdeado','5002':'Ultramarine Blue / Azul Ultramarino','5003':'Sapphire Blue / Azul Safira','5004':'Black Blue / Azul Escuro',
  '5005':'Signal Blue / Azul Sinal','5007':'Brillant Blue / Azul Brilhante','5008':'Grey Blue / Azul Acinzentado','5009':'Azure Blue / Azul Celeste','5010':'Gentian Blue / Azul Genciana',
  '5011':'Steel Blue / Azul Aço','5012':'Light Blue / Azul Claro','5013':'Cobalt Blue / Azul Cobalto','5014':'Pigeon Blue / Azul Pombo','5015':'Sky Blue / Azul Céu',
  '5017':'Traffic Blue / Azul Tráfego','5018':'Turquoise Blue / Azul Turquesa','5019':'Capri Blue / Azul Capri','5020':'Ocean Blue / Azul Oceano','5021':'Water Blue / Azul Água',
  '5022':'Night Blue / Azul Noite','5023':'Distant Blue / Azul Distante','5024':'Pastel Blue / Azul Pastel','5025':'Pearl Gentian Blue / Azul Genciana Pérola','5026':'Pearl Night Blue / Azul Noite Pérola',
  '6000':'Patina Green / Verde Pátina','6001':'Emerald Green / Verde Esmeralda','6002':'Leaf Green / Verde Folha','6003':'Olive Green / Verde Oliva','6004':'Blue Green / Verde Azulado',
  '6005':'Moss Green / Verde Musgo','6006':'Grey Olive / Oliva Acinzentado','6007':'Bottle Green / Verde Garrafa','6008':'Brown Green / Verde Marrom','6009':'Fir Green / Verde Abeto',
  '6010':'Grass Green / Verde Grama','6011':'Reseda Green / Verde Resedá','6012':'Black Green / Verde Escuro','6013':'Reed Green / Verde Junco','6014':'Yellow Olive / Oliva Amarelado',
  '6015':'Black Olive / Oliva Escuro','6016':'Turquoise Green / Verde Turquesa','6017':'May Green / Verde Maio','6018':'Yellow Green / Verde Amarelado','6019':'Pastel Green / Verde Pastel',
  '6020':'Chrome Green / Verde Cromo','6021':'Pale Green / Verde Pálido','6022':'Olive Drab / Oliva Fosco','6024':'Traffic Green / Verde Tráfego','6025':'Fern Green / Verde Samambaia',
  '6026':'Opal Green / Verde Opala','6027':'Light Green / Verde Claro','6028':'Pine Green / Verde Pinho','6029':'Mint Green / Verde Menta','6032':'Signal Green / Verde Sinal',
  '6033':'Mint Turquoise / Turquesa Menta','6034':'Pastel Turquoise / Turquesa Pastel','6035':'Pearl Green / Verde Pérola','6036':'Pearl Opal Green / Verde Opala Pérola','6037':'Pure Green / Verde Puro',
  '7000':'Squirrel Grey / Cinza Esquilo','7001':'Silver Grey / Cinza Prata','7002':'Olive Grey / Cinza Oliva','7003':'Moss Grey / Cinza Musgo','7004':'Signal Grey / Cinza Sinal',
  '7005':'Mouse Grey / Cinza Rato','7006':'Beige Grey / Cinza Bege','7008':'Khaki Grey / Cinza Cáqui','7009':'Green Grey / Cinza Esverdeado','7010':'Tarpaulin Grey / Cinza Lona',
  '7011':'Iron Grey / Cinza Ferro','7012':'Basalt Grey / Cinza Basalto','7013':'Brown Grey / Cinza Marrom','7015':'Slate Grey / Cinza Ardósia','7016':'Anthracite Grey / Cinza Antracite',
  '7021':'Black Grey / Cinza Escuro','7022':'Umbra Grey / Cinza Úmbria','7023':'Concrete Grey / Cinza Concreto','7024':'Graphite Grey / Cinza Grafite','7026':'Granite Grey / Cinza Granito',
  '7030':'Stone Grey / Cinza Pedra','7031':'Blue Grey / Cinza Azulado','7032':'Pebble Grey / Cinza Seixo','7033':'Cement Grey / Cinza Cimento','7034':'Yellow Grey / Cinza Amarelado',
  '7035':'Light Grey / Cinza Claro','7036':'Platinum Grey / Cinza Platina','7037':'Dusty Grey / Cinza Poeira','7038':'Agate Grey / Cinza Ágata','7039':'Quartz Grey / Cinza Quartzo',
  '7040':'Window Grey / Cinza Janela','7042':'Traffic Grey A / Cinza Tráfego A','7043':'Traffic Grey B / Cinza Tráfego B','7044':'Silk Grey / Cinza Seda','7045':'Telegrey 1 / Telecinza 1',
  '7046':'Telegrey 2 / Telecinza 2','7047':'Telegrey 4 / Telecinza 4','7048':'Pearl Mouse Grey / Cinza Rato Pérola',
  '8000':'Green Brown / Marrom Esverdeado','8001':'Ochre Brown / Marrom Ocre','8002':'Signal Brown / Marrom Sinal','8003':'Clay Brown / Marrom Argila','8004':'Copper Brown / Marrom Cobre',
  '8007':'Fawn Brown / Marrom Cervo','8008':'Olive Brown / Marrom Oliva','8011':'Nut Brown / Marrom Castanha','8012':'Red Brown / Marrom Avermelhado','8014':'Sepia Brown / Marrom Sépia',
  '8015':'Chestnut Brown / Marrom Castanho','8016':'Mahogany Brown / Marrom Mogno','8017':'Chocolate Brown / Marrom Chocolate','8019':'Grey Brown / Marrom Acinzentado','8022':'Black Brown / Marrom Escuro',
  '8023':'Orange Brown / Marrom Alaranjado','8024':'Beige Brown / Marrom Bege','8025':'Pale Brown / Marrom Pálido','8028':'Terra Brown / Marrom Terra','8029':'Pearl Copper / Cobre Pérola',
  '9001':'Cream / Creme','9002':'Grey White / Branco Acinzentado','9003':'Signal White / Branco Sinal','9004':'Signal Black / Preto Sinal','9005':'Jet Black / Preto Intenso',
  '9006':'White Aluminium / Alumínio Branco','9007':'Grey Aluminium / Alumínio Cinza','9010':'Pure White / Branco Puro','9011':'Graphite Black / Preto Grafite','9016':'Traffic White / Branco Tráfego',
  '9017':'Traffic Black / Preto Tráfego','9018':'Papyrus White / Branco Papiro','9022':'Pearl Light Grey / Cinza Claro Pérola','9023':'Pearl Dark Grey / Cinza Escuro Pérola'
};

/* ─── DADOS DE PRODUTO ─── */
const B="https://eurolatinatintas.com.br";
const searchUrl=(code)=>`${B}/search?options%5Bfields%5D=title%2Ctag%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku&options%5Bprefix%5D=last&q=${code}`;

const LINHAS={
  PRS:{nome:'Primer Sintético',tipo:'Metal Mecânica',base:'Alquídica',rM:8,rX:12,dft:'30-40 μm',mono:true,cat:null,catProp:null,dil:'dl-9-diluente-esmalte-sinttico-universal',dilNome:'DL-9 Diluente Sintético',
    rals:['7040','8004','9003'],
    handleMap:{'7040':'prs-7040-primer-sinttico-cinza-ral-7040','8004':'prs-8004-primer-sinttico-vermelho-oxido-ral-8004','9003':'prs-9003-primer-sinttico-branco-ral-9003'}},
  TMSR:{nome:'Esmalte Sintético',tipo:'Metal Mecânica',base:'Alquídica',rM:8,rX:12,dft:'46 μm',mono:true,cat:null,catProp:null,dil:'dl-9-diluente-esmalte-sinttico-universal',dilNome:'DL-9 Diluente Sintético',
    handleTpl:'{L}-{RAL}-tintas-esmaltes',amb:'C1-C2',sol:'47%',secT:'15-20 min',secF:'24h',potLife:null,comp:'Resina alquídica',temp:'60°C'},
  TMER:{nome:'Epóxi Standard 2K',tipo:'Metal Mecânica',base:'Epóxi',rM:8,rX:8,dft:'60-70 μm',mono:false,cat:'ctl-30-catalisadores',catNome:'CTL-30 Catalisador Epóxi 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    handleTpl:'{L}-{RAL}-tinta-epoxi-bicomponente',amb:'C3-C5',sol:'55-65%',secT:'4-6h',secF:'72h',potLife:'1h',comp:'Epóxi alto sólidos + Poliamida',temp:'60°C'},
  TMED:{nome:'Epóxi Dupla Função',tipo:'Metal Mecânica',base:'Epóxi',rM:8,rX:8,dft:'120-130 μm',mono:false,cat:'ctl-30-catalisadores',catNome:'CTL-30 Catalisador Epóxi 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    handleTpl:'{L}-{RAL}-tinta-epoxi-metal-dupla-funcao',amb:'C2-C4',sol:'82%',secT:'40-60 min',secF:'24h',potLife:'4h',comp:'Epóxi (Bisfenol A) + Poliamida',temp:'100°C'},
  TPUR:{nome:'PU Alifático',tipo:'Metal Mecânica',base:'Poliuretano',rM:10,rX:10,dft:'80-90 μm',mono:false,cat:'cal-200-catalisadores',catNome:'CAL-200 Catalisador PU 3:1',catProp:3,dil:'dl-600-diluente-para-pu-acrilico',dilNome:'DL-600 Diluente PU',
    handleTpl:'{L}-{RAL}-tintas-pu-bicomponente',amb:'C4-C5',sol:'76%',secT:'60 min',secF:'48h',potLife:'4h',comp:'Acrílica hidroxilada + Isocianato',temp:'60°C'},
  EXA:{nome:'Exaprimer Piso',tipo:'Piso Industrial',base:'Epóxi',rM:8,rX:8,dft:'50 μm',mono:false,cat:'ctl-30-catalisadores',catNome:'CTL-30 Catalisador Epóxi 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    rals:['7016','7033','7038','7040','7044','9003'],
    handleMap:{'7016':'tmed-exa-7016-tinta-epoxi-metal-dupla-funcao','7033':'tmed-exa-7033-tinta-epoxi-metal-dupla-funcao','7038':'tmed-exa-7038-tinta-epoxi-metal-dupla-funcao','7040':'tmed-exa-7040-tinta-epoxi-metal-dupla-funcao','7044':'tmed-exa-7044-tinta-epoxi-metal-dupla-funcao','9003':'tmed-exa-9003-tinta-epoxi-metal-dupla-funcao'},
    amb:'Pisos (selante)',sol:'76%',secT:'2-4h',secF:'24-48h',potLife:'4h',comp:'Epóxi primer',temp:'N/A'},
  EXAR:{nome:'Exapiso',tipo:'Piso Industrial',base:'Epóxi',rM:8,rX:8,dft:'150 μm',mono:false,cat:'ctl-30-catalisadores',catNome:'CTL-30 Catalisador Epóxi 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    rals:['1006','1021','2004','3009','3020','5005','5015','5021','6026','6029','6032','7011','7016','7034','7037','7038','7040','7042','7044','9002','9005'],
    handleTpl:'exar-{RAL}-epoxi-bicomponente',amb:'Pisos alto tráfego',sol:'65%',secT:'2-4h',secF:'24-48h',potLife:'4h',comp:'Epóxi bicomponente pisos',temp:'N/A'},
  ECR:{nome:'Eurocoat',tipo:'Piso Industrial',base:'Epóxi',rM:5,rX:5,dft:'100 μm',mono:false,cat:'cat-82-catalisadores',catNome:'CAT-82 Catalisador Eurocoat 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    rals:['1006','1021','2004','3009','3020','5005','5015','5021','6029','7011','7034','7035','7037','7038','7040','7042','7044','8014','9002','9003','9005'],
    handleTpl:'ecr-{RAL}-epoxi-bicomponente',amb:'Pisos industriais',sol:'84%',secT:'2-4h',secF:'24-48h',potLife:'1h',comp:'Epóxi alto sólidos + Poliamina',temp:'N/A'},
  TCPR:{nome:'PU Piso',tipo:'Piso Industrial',base:'Poliuretano',rM:10,rX:13,dft:'60 μm',mono:false,cat:'cal-222-catalisadores',catNome:'CAL-222 Catalisador PU Piso 3:1',catProp:3,dil:'dl-600-diluente-para-pu-acrilico',dilNome:'DL-600 Diluente PU',
    rals:['1006','1021','2004','3009','3020','5005','5015','5021','6026','6029','6032','7011','7016','7033','7034','7035','7037','7038','7040','7042','7044'],
    handleTpl:'tcpr-{RAL}-tintas-pu-bicomponente',amb:'Pisos alta exigência',sol:'60%',secT:'40-60 min',secF:'48h',potLife:'2h',comp:'Poliacrilato + Poliisocianurato',temp:'60°C'},
  TAT:{nome:'Alta Temperatura',tipo:'Metal Mecânica',base:'Silicone',rM:6,rX:10,dft:'28-45 μm',mono:true,cat:null,catProp:null,dil:'dl-9-diluente-esmalte-sinttico-universal',dilNome:'DL-9 Diluente Sintético',
    rals:['200','300','450','600'],
    handleMap:{'200':'tat-200-tinta-alta-temperatura-at-200-graus-alumnio-ral','300':'tat-300-tinta-alta-temperatura-at-300-graus-alumnio-ral','450':'tat-450-tinta-alta-temperatura-at-450-graus-alumnio-ral','600':'tat-600-tinta-alta-temperatura-at-600-graus-alumnio-ral'},
    ralLabels:{'200':'Até 200°C','300':'Até 300°C','450':'Até 450°C','600':'Até 600°C'},
    amb:'200-600°C',sol:'31-54%',secT:'5-10 min',secF:'24h + cura térmica',potLife:null,comp:'Resina de silicone',temp:'200°C a 600°C'},
  TME:{nome:'Eurolac',tipo:'Metal Mecânica',base:'Epóxi Fenólico',rM:5.5,rX:5.5,dft:'120-150 μm',mono:false,cat:'cat-85-catalisadores',catNome:'CAT-85 Catalisador Eurolac 3:1',catProp:3,dil:'dl-700-diluente',dilNome:'DL-700 Diluente Epóxi',
    rals:['499','501','727','756','758'],
    handleMap:{'499':'tme-499-epoxi-eurolack','501':'tme-501-epoxi-eurolack','727':'tme-727-epoxi-eurolack','756':'tme-756-epoxi-eurolack','758':'tme-758-epoxi-eurolack'},
    ralLabels:{'499':'Cinza','501':'Preto','727':'Branco','756':'Platina','758':'Branco Polar'},
    amb:'Alimentos/Tanques',sol:'58%',secT:'4-6h',secF:'72h',potLife:'4h',comp:'Epóxi fenólico',temp:'60°C'}
};

/* Products for calculator tab (linhas com rendimento definido) */
const CALC_P=['PRS','TMSR','TMED','TMER','TPUR','EXA','ECR','EXAR'];

/* RAL master list */
const RAL_FULL=[
  '1001','1002','1003','1004','1005','1006','1007','1011','1012','1013','1014','1015','1016','1017','1018',
  '1019','1020','1021','1023','1024','1027','1028','1032','1033','1034','1035','1036','1037',
  '2000','2001','2002','2003','2004','2005','2008','2009','2010','2011','2012','2013',
  '3000','3001','3002','3003','3004','3005','3007','3009','3011','3012','3013','3014','3015','3016','3017','3018','3020','3022','3024','3026','3027','3028','3031','3032','3033',
  '4001','4002','4003','4004','4005','4006','4007','4008','4009','4010','4011','4012',
  '5000','5001','5002','5003','5004','5005','5007','5008','5009','5010','5011','5012','5013','5014','5015','5017','5018','5019','5020','5021','5022','5023','5024','5025','5026',
  '6000','6001','6002','6003','6004','6005','6006','6007','6008','6009','6010','6011','6012','6013','6014','6015','6016','6017','6018','6019','6020','6021','6022','6024','6025','6026','6027','6028','6029','6032','6033','6034','6035','6036','6037',
  '7000','7001','7002','7003','7004','7005','7006','7008','7009','7010','7011','7012','7013','7015','7016','7021','7022','7023','7024','7026','7030','7031','7032','7033','7034','7035','7036','7037','7038','7039','7040','7042','7043','7044','7045','7046','7047','7048',
  '8000','8001','8002','8003','8004','8007','8008','8011','8012','8014','8015','8016','8017','8019','8022','8023','8024','8025','8028','8029',
  '9001','9002','9003','9004','9005','9006','9007','9010','9011','9016','9017','9018'
];

/* Categorias de cores RAL por prefixo */
const RAL_CATS=[
  {id:'1',label:'Amarelos',cor:'#E5BE01',prefix:'1'},
  {id:'2',label:'Laranjas',cor:'#ED760E',prefix:'2'},
  {id:'3',label:'Vermelhos',cor:'#AF2B1E',prefix:'3'},
  {id:'4',label:'Violetas',cor:'#6D3461',prefix:'4'},
  {id:'5',label:'Azuis',cor:'#354D73',prefix:'5'},
  {id:'6',label:'Verdes',cor:'#316650',prefix:'6'},
  {id:'7',label:'Cinzas',cor:'#78858B',prefix:'7'},
  {id:'8',label:'Marrons',cor:'#826C34',prefix:'8'},
  {id:'9',label:'Brancos/Pretos',cor:'#282828',prefix:'9'}
];

/* ISO 12944 data */
const ISO={
  C1:{sl:'Muito Baixa',d:'Interiores secos, clima controlado',dft:'80-120 μm',cam:'1-2',
    s:[{p:'TMSR',f:'Esmalte Sintético direto'}],cor:'#22C55E'},
  C2:{sl:'Baixa',d:'Interiores com condensação, exteriores rurais',dft:'120-200 μm',cam:'2-3',
    s:[{p:'PRS',f:'Primer Sintético'},{p:'TMSR',f:'Acabamento Esmalte Sintético'}],cor:'#84CC16'},
  C3:{sl:'Média',d:'Exteriores urbanos/industriais',dft:'200-280 μm',cam:'3',
    s:[{p:'TMED',f:'Primer Epóxi Dupla Função'},{p:'TMED',f:'Intermediária Epóxi'},{p:'TPUR',f:'Acabamento PU Alifático'}],cor:'#EAB308'},
  C4:{sl:'Alta',d:'Industrial alta umidade, costeiro',dft:'280-360 μm',cam:'4',
    s:[{p:'TMER',f:'Primer Epóxi 2K'},{p:'TMER',f:'Intermediária Epóxi 2K'},{p:'TPUR',f:'Acabamento PU Alifático'}],cor:'#F97316'},
  C5:{sl:'Muito Alta',d:'Condensação permanente, maresia',dft:'360-500 μm',cam:'5+',
    s:[{p:'TMER',f:'Primer rico em zinco'},{p:'TMER',f:'Barreira Epóxi 2K (2x)'},{p:'TPUR',f:'Acabamento PU Alifático'}],cor:'#EF4444'}
};

/* ─── ÍCONES SVG ─── */
const ICO={
  calc:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="12" y1="18" x2="16" y2="18"/></svg>',
  layers:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
  cart:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
  check:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
  plus:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
  receipt:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2-3 2-3-2z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="12" y2="16"/></svg>',
  search:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
  x:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
  drop:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>',
  shield:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
  gauge:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',
  bucket:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 6c0-1.1 1.57-2 3.5-2h7C17.43 4 19 4.9 19 6v12c0 1.1-1.57 2-3.5 2h-7C6.57 20 5 19.1 5 18V6z"/><ellipse cx="12" cy="6" rx="7" ry="2"/></svg>',
  trending:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>',
  alert:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  info:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
  arrow:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
  area:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="3" x2="9" y2="21"/></svg>',
  chevron:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
};

/* ─── HELPERS ─── */
const $=(s,p)=>(p||document).querySelector(s);
const $$=(s,p)=>[...(p||document).querySelectorAll(s)];
const el=document.getElementById('el-ot');
if(!el) return;

/* ─── PERDA: método + geometria ─── */
function calcPerda(metodo,geometria){
  if(metodo==='rolo') return 15;
  if(metodo==='pistola'){
    if(geometria==='planas') return 12;
    if(geometria==='perfis') return 25;
    if(geometria==='grades') return 80;
  }
  return 15;
}

/* ─── EMBALAGEM INTELIGENTE ─── */
function calcPackaging(litros){
  if(litros<=0) return [{label:'3,6L',n18:0,n36:0,total:0,waste:0,recommended:true},{label:'18L',n18:0,n36:0,total:0,waste:0},{label:'Misto',n18:0,n36:0,total:0,waste:0}];
  const only36=Math.ceil(litros/3.6);const total36=only36*3.6;
  const only18=Math.ceil(litros/18);const total18=only18*18;
  const big=Math.floor(litros/18);const remainder=litros-(big*18);
  const small=remainder>0.01?Math.ceil(remainder/3.6):0;
  const totalMix=(big*18)+(small*3.6);
  const opts=[
    {label:'3,6L',n18:0,n36:only36,total:total36,waste:+(total36-litros).toFixed(1)},
    {label:'18L',n18:only18,n36:0,total:total18,waste:+(total18-litros).toFixed(1)},
    {label:'Misto',n18:big,n36:small,total:totalMix,waste:+(totalMix-litros).toFixed(1)}
  ];
  opts.sort((a,b)=>a.waste-b.waste);
  opts[0].recommended=true;
  return opts;
}
function packDesc(opt){
  const parts=[];
  if(opt.n18>0) parts.push(opt.n18+'x 18L');
  if(opt.n36>0) parts.push(opt.n36+'x 3,6L');
  return parts.join(' + ')||(opt.label);
}
function packDescAll(litros){
  const opts=calcPackaging(litros);
  const rec=opts.find(o=>o.recommended);
  return rec?packDesc(rec):'';
}

const fmt=v=>v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
const fmtR=v=>v>=1e6?`R$ ${(v/1e6).toFixed(1)}M`:v>=1e3?`R$ ${(v/1e3).toFixed(0)}k`:`R$ ${v.toFixed(0)}`;
const clamp=(v,mn,mx)=>Math.min(mx,Math.max(mn,v));

function ralHex(code){ return RAL_HEX[code]||'#888'; }
function ralName(code){ return RAL_NAMES[code]||''; }
function ralSwatch(code,size){
  size=size||16;
  const hex=ralHex(code);
  const light=isLightColor(hex)?'ral-swatch--light':'';
  return `<span class="ral-swatch ${light}" data-hex="${hex}" style="width:${size}px;height:${size}px;border-radius:3px;display:inline-block;flex-shrink:0"></span>`;
}

/* Apply solid colors via JS to bypass Shopify theme CSS overrides */
function applyOtSwatchColors(ctx){
  (ctx||document).querySelectorAll('.ral-swatch[data-hex]').forEach(function(sw){
    var hex=sw.getAttribute('data-hex');
    if(hex) sw.style.setProperty('background-color',hex,'important');
  });
}

/* SVG arrows for scroll buttons */
const ARROW_LEFT='<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const ARROW_RIGHT='<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

/* ─── GENERIC SCROLL ARROWS ─── */
function addScrollArrows(wrapSelector, scrollSelector, ctx){
  const wraps=$$(wrapSelector,ctx);
  wraps.forEach(wrap=>{
    const scrollEl=wrap.querySelector(scrollSelector);
    if(!scrollEl) return;
    let leftBtn=wrap.querySelector('.ot-scroll-arrow.left');
    let rightBtn=wrap.querySelector('.ot-scroll-arrow.right');
    if(!leftBtn){
      leftBtn=document.createElement('button');leftBtn.className='ot-scroll-arrow left';leftBtn.innerHTML=ARROW_LEFT;
      rightBtn=document.createElement('button');rightBtn.className='ot-scroll-arrow right';rightBtn.innerHTML=ARROW_RIGHT;
      wrap.style.position='relative';
      wrap.appendChild(leftBtn);wrap.appendChild(rightBtn);
    }
    function update(){
      const canL=scrollEl.scrollLeft>4;
      const canR=scrollEl.scrollLeft<scrollEl.scrollWidth-scrollEl.clientWidth-4;
      leftBtn.style.display=canL?'flex':'none';
      rightBtn.style.display=canR?'flex':'none';
    }
    scrollEl.addEventListener('scroll',update);
    leftBtn.addEventListener('click',()=>scrollEl.scrollBy({left:-200,behavior:'smooth'}));
    rightBtn.addEventListener('click',()=>scrollEl.scrollBy({left:200,behavior:'smooth'}));
    setTimeout(update,50);
  });
}

/* Get 1st product image (product/can photo) */
function getProductImage(p){
  if(!p) return '';
  if(p.images && p.images.length>0) return p.images[0].src||p.images[0]||'';
  return p.featured_image||'';
}
/* Get 2nd product image (actual color photo) with fallback to 1st */
function getColorImage(p){
  if(!p) return '';
  if(p.images && p.images.length>1) return p.images[1].src||p.images[1]||'';
  return getProductImage(p);
}

/* Load 2nd product image into a ral-swatch element */
var imgCache2={};
function loadSwatchImage(swatchEl,handle){
  if(!handle) return;
  if(imgCache2[handle]){insertSwatchImg(swatchEl,imgCache2[handle]);return;}
  fetch('/products/'+handle+'.json')
    .then(function(r){return r.json();})
    .then(function(data){
      if(data.product && data.product.images && data.product.images.length>1){
        var src=data.product.images[1].src;
        var url=src+(src.indexOf('?')>-1?'&':'?')+'width=80';
        imgCache2[handle]=url;
        insertSwatchImg(swatchEl,url);
      }
    })
    .catch(function(){});
}

function insertSwatchImg(sw,url){
  if(!sw||sw.querySelector('img')) return;
  var img=document.createElement('img');
  img.src=url;img.alt='';
  img.style.cssText='position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;opacity:0;transition:opacity .3s';
  img.onload=function(){img.style.opacity='1';};
  sw.style.position='relative';sw.style.overflow='hidden';
  sw.appendChild(img);
}

/* Load 2nd images for ral-item swatches in batch */
function loadRalItemImages(ctx,linha,rals){
  if(!rals||!rals.length) return;
  var items=ctx.querySelectorAll('.ral-item .ral-swatch');
  var idx=0;
  function nextBatch(){
    var end=Math.min(idx+4,items.length);
    for(var i=idx;i<end;i++){
      var item=items[i].closest('.ral-item');
      var ral=item?item.getAttribute('data-ral-pick')||item.getAttribute('data-iso-ral-pick')||item.getAttribute('data-comp-ral-pick')||item.getAttribute('data-roi-ral-pick')||item.getAttribute('data-piso-ral-pick'):'';
      if(ral){
        var handle=getHandle(linha,ral);
        if(handle) loadSwatchImage(items[i],handle);
      }
    }
    idx=end;
    if(idx<items.length) setTimeout(nextBatch,200);
  }
  nextBatch();
}
function isLightColor(hex){
  const r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  return (r*299+g*587+b*114)/1000>180;
}

function getRend(linha,sub){
  const l=LINHAS[linha];
  if(sub==='liso') return l.rX;
  if(sub==='rugoso') return l.rM;
  return (l.rM+l.rX)/2;
}

function getHandle(linha,ral){
  const l=LINHAS[linha];
  if(l.handleMap) return l.handleMap[ral]||null;
  if(l.handleTpl) return l.handleTpl.replace('{L}',linha.toLowerCase()).replace('{RAL}',ral);
  return null;
}

function getRals(linha){
  const l=LINHAS[linha];
  if(l.rals) return l.rals;
  return RAL_FULL;
}

function makeStat(label,value,color,iconSvg,sub){
  return `<div class="stat">${iconSvg?`<div class="stat-icon" style="color:${color||'var(--ot-muted)'}">${iconSvg}</div>`:''}<div class="stat-label">${label}</div><div class="stat-value" style="color:${color||'var(--ot-text)'}">${value}</div>${sub?`<div class="stat-sub">${sub}</div>`:''}</div>`;
}

function makeDisclaimer(){
  return `<p class="disclaimer">Especificações podem variar por cor e formulação. Consulte a ficha técnica do produto em <a href="${B}" target="_blank">nosso site</a>.</p>`;
}

function makeFontes(arr){
  return `<div class="fontes"><h4>Fontes</h4>${arr.map(f=>`<span>${f}</span>`).join('')}</div>`;
}

function makeStepper(key,val,min,max,step,unit){
  return `<div class="stepper" data-k="${key}" data-min="${min}" data-max="${max}" data-step="${step}"><button class="stepper-btn" data-dir="-1" type="button">&#8722;</button><div class="stepper-val">${val}<span class="stepper-unit">${unit}</span></div><button class="stepper-btn" data-dir="1" type="button">+</button></div>`;
}

function validateInput(inp){
  const mn=+inp.min||0;
  const v=+inp.value;
  if(isNaN(v)||v<mn){inp.classList.add('invalid');return false}
  inp.classList.remove('invalid');return true;
}

/* ─── SHOPIFY CART API ─── */
const prodCache={};
async function fetchProduct(handle){
  if(prodCache[handle]) return prodCache[handle];
  try{
    const r=await fetch('/products/'+handle+'.js');
    if(!r.ok) return null;
    const d=await r.json();
    prodCache[handle]=d;
    return d;
  }catch(e){return null;}
}

async function addToCart(variantId,qty){
  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:Number(variantId),quantity:Number(qty)}]})
    });
    if(!r.ok){
      const err=await r.json().catch(()=>null);
      console.warn('Cart API error:',err);
      return false;
    }
    return true;
  }catch(e){console.warn('Cart fetch error:',e);return false;}
}

async function addMultipleToCart(items){
  try{
    const payload=items.map(it=>({id:Number(it.id),quantity:Number(it.quantity)}));
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:payload})
    });
    return r.ok;
  }catch(e){return false;}
}

/* ─── CART UI REFRESH ─── */
async function refreshCartUI(){
  try{
    const r=await fetch('/cart.js',{headers:{'Content-Type':'application/json'}});
    if(!r.ok) return;
    const cart=await r.json();
    const cnt=cart.item_count||0;
    /* Update common Shopify theme cart count selectors */
    const sels=['.cart-count-bubble span','.cart-count','[data-cart-count]','.js-cart-count','.cart-item-count','#CartCount','.site-header__cart-count','cart-count'];
    sels.forEach(s=>{
      document.querySelectorAll(s).forEach(el=>{
        if(el.tagName==='CART-COUNT'){el.setAttribute('count',cnt);el.textContent=cnt;}
        else el.textContent=cnt;
        if(cnt>0) el.style.display='';
      });
    });
    /* Dispatch event for custom themes */
    document.dispatchEvent(new CustomEvent('cart:refresh',{detail:cart}));
  }catch(e){console.warn('Cart UI refresh error:',e);}
}

/* Find variant by volume label (robust: checks contains, not exact match) */
function findVariant(product,volLabel){
  if(!product||!product.variants) return null;
  const exact=product.variants.find(v=>v.title===volLabel);
  if(exact) return exact;
  const contains=product.variants.find(v=>v.title.includes(volLabel.replace('L','')));
  if(contains) return contains;
  return product.variants[0]||null;
}

/* ─── TAB STATE ─── */
let activeTab='orcamento';

/* ─── GLOBAL STATE: ORÇAMENTO ─── */
const state={
  area:100,
  sub:'medio',
  metodo:'rolo',
  geometria:'planas',
  camadas:[{linha:'PRS',ral:'',dem:1,vol:'misto',product:null}],
  cartFeedback:{}
};

/* ─── TAB SWITCHING ─── */
function switchTab(id){
  activeTab=id;
  renderShell();
}

/* ─── RENDER SHELL (tabs + active content) ─── */
function renderShell(){
  const tabs=[
    {id:'orcamento',label:'Orçamento',ico:ICO.calc},
    {id:'iso',label:'Corrosividade',ico:ICO.shield},
    {id:'comp',label:'Comparativo',ico:ICO.layers},
    {id:'roi',label:'ROI',ico:ICO.trending},
    {id:'piso',label:'Piso Industrial',ico:ICO.area}
  ];

  let h=`<div class="ot-tab-bar" id="otTabBar" role="tablist">`;
  tabs.forEach(t=>{
    h+=`<button class="ot-tab ${activeTab===t.id?'active':''}" data-tab="${t.id}" role="tab" aria-selected="${activeTab===t.id}">${t.ico}<span>${t.label}</span></button>`;
  });
  h+=`</div>`;
  h+=`<div class="ot-tab-content" id="otContent"></div>`;

  const pw=$('.page-wrap',el);
  if(!pw) return;
  pw.innerHTML=h;

  /* Tab events */
  $$('.ot-tab',el).forEach(btn=>{
    btn.addEventListener('click',()=>switchTab(btn.dataset.tab));
  });

  /* Render active tab */
  const content=$('#otContent',el);
  switch(activeTab){
    case 'orcamento': renderOrcamento(content); break;
    case 'iso': renderISO(content); break;
    case 'comp': renderComp(content); break;
    case 'roi': renderROI(content); break;
    case 'piso': renderPiso(content); break;
  }
}

/* ═══════════════════════════════════════════════════════════
   TAB 1: ORÇAMENTO TÉCNICO
   ═══════════════════════════════════════════════════════════ */
function renderOrcamento(container){
  let h='';

  /* Dados do projeto */
  h+=`<div class="sec-label mb-16">${ICO.calc}<h2>Dados do Projeto</h2></div>`;
  h+=`<div class="bento mb-24">`;
  h+=`<div class="grid-2">`;
  h+=`<div class="field"><label>Área total</label><div class="field-wrap"><input type="number" id="otArea" value="${state.area}" min="1" max="100000" inputmode="numeric" class="has-unit"><span class="unit">m²</span></div></div>`;
  h+=`<div class="field"><label>Tipo de substrato</label><div class="seg" role="radiogroup">`;
  ['liso','medio','rugoso'].forEach(s=>{
    h+=`<button class="${state.sub===s?'active':''}" data-sub="${s}">${s.charAt(0).toUpperCase()+s.slice(1)}</button>`;
  });
  h+=`</div></div>`;
  h+=`</div>`;

  /* Método de aplicação + geometria */
  h+=`<div class="field mt-16"><label>Método de aplicação</label><div class="seg" role="radiogroup">`;
  ['rolo','pistola'].forEach(m=>{
    h+=`<button class="${state.metodo===m?'active':''}" data-metodo="${m}">${m==='rolo'?'Rolo':'Pistola'}</button>`;
  });
  h+=`</div></div>`;
  if(state.metodo==='pistola'){
    h+=`<div class="field mt-16"><label>Geometria da superfície</label><div class="seg" role="radiogroup">`;
    [['planas','Superfícies planas'],['perfis','Perfis e estruturas'],['grades','Grades e treliças']].forEach(([k,v])=>{
      h+=`<button class="${state.geometria===k?'active':''}" data-geometria="${k}">${v}</button>`;
    });
    h+=`</div></div>`;
  }
  const _perda=calcPerda(state.metodo,state.geometria);
  h+=`<div style="display:flex;align-items:center;gap:8px;padding:10px 14px;background:var(--ot-accent-soft);border-radius:10px;margin-top:12px;font-size:13px;font-weight:500;color:var(--ot-accent)">${ICO.info} Perda estimada: ${_perda}%</div>`;
  h+=`</div>`;

  /* Camadas */
  h+=`<div class="sec-label mb-16">${ICO.layers}<h2>Camadas do Sistema</h2></div>`;

  const perdaOrc=calcPerda(state.metodo,state.geometria);
  state.camadas.forEach((cam,i)=>{
    const l=LINHAS[cam.linha];
    const rals=getRals(cam.linha);
    const rend=getRend(cam.linha,state.sub);
    const litros=state.area>0?(state.area/rend)*(1+perdaOrc/100)*cam.dem:0;
    const pkg=calcPackaging(litros);
    const recPkg=pkg.find(o=>o.recommended)||pkg[0];
    const lataCap=cam.vol==='18L'?18:cam.vol==='3.6L'?3.6:0;
    const latas=cam.vol==='misto'?0:(litros>0?Math.ceil(litros/lataCap):0);

    h+=`<div class="layer-card" data-layer="${i}">`;
    h+=`<div class="layer-header"><div class="layer-num">${i+1}</div><div class="layer-title">Camada ${i+1}</div>`;
    if(state.camadas.length>1) h+=`<button class="ot-remove" data-remove="${i}" title="Remover camada">${ICO.x}</button>`;
    h+=`</div>`;

    /* Linha de produto */
    h+=`<div class="layer-row"><div class="layer-row-label">Linha de produto</div>`;
    h+=`<div class="chip-group">`;
    Object.entries(LINHAS).forEach(([k,v])=>{
      h+=`<button class="chip ${cam.linha===k?'active':''}" data-linha="${k}" data-layer="${i}">${k}<span class="chip-sub">${v.nome}</span></button>`;
    });
    h+=`</div></div>`;

    /* RAL */
    h+=`<div class="layer-row"><div class="layer-row-label">${l.ralLabels?'Cor':'Código RAL'}</div>`;
    if(!cam.ral){
      const hasCategories=!l.ralLabels && rals.length>20;
      h+=`<div class="ral-search">`;
      if(hasCategories){
        h+=`<div class="ral-cat-bar">`;
        RAL_CATS.forEach(cat=>{
          h+=`<button class="ral-cat-chip" data-cat="${cat.prefix}" data-layer="${i}" style="--cat-color:${cat.cor}"><span style="width:12px;height:12px;background:${cat.cor};border-radius:3px;display:inline-block;flex-shrink:0"></span> ${cat.label}</button>`;
        });
        h+=`<button class="ral-cat-chip" data-cat="all" data-layer="${i}">Todas</button>`;
        h+=`</div>`;
      }
      h+=`<div class="ral-search-wrap"><span class="ral-search-icon">${ICO.search}</span>`;
      h+=`<input type="text" class="ral-search-input" placeholder="${l.ralLabels?'Selecione a cor':'Buscar RAL (ex: 7035, cinza, grey...)'}" data-ral-input="${i}" autocomplete="off"></div>`;
      h+=`<div class="ral-results" data-ral-list="${i}"></div></div>`;
    }else{
      const label=l.ralLabels?l.ralLabels[cam.ral]:'RAL '+cam.ral;
      const name=l.ralLabels?'':(' '+ralName(cam.ral));
      h+=`<div class="ral-selected">${ralSwatch(cam.ral,20)}<span>${label}${name}</span><button class="ral-clear" data-ral-clear="${i}">Trocar</button></div>`;
    }
    h+=`</div>`;

    /* Demãos + Volume */
    h+=`<div class="layer-row"><div class="layer-inline">`;
    h+=`<div><div class="layer-row-label">Demãos</div><div class="seg" role="radiogroup">`;
    [1,2,3,4,5].forEach(n=>{
      h+=`<button class="${cam.dem===n?'active':''}" data-dem="${n}" data-layer="${i}">${n}</button>`;
    });
    h+=`</div></div>`;
    h+=`<div><div class="layer-row-label">Volume da lata</div><div class="seg" role="radiogroup">`;
    ['3.6L','18L','misto'].forEach(v=>{
      const lbl=v==='misto'?'Misto':v;
      h+=`<button class="${cam.vol===v?'active':''}" data-vol="${v}" data-layer="${i}">${lbl}</button>`;
    });
    h+=`</div></div>`;
    h+=`</div></div>`;

    /* Product preview */
    if(cam.ral && cam.product){
      const p=cam.product;
      /* Para misto, usamos 18L como referência de preço */
      const volRef=cam.vol==='misto'?'18L':cam.vol;
      const variant=findVariant(p,volRef);
      const price=variant?variant.price/100:0;
      /* Calcular custo real baseado no packaging */
      const effLatas=cam.vol==='misto'?recPkg.n18:latas;
      const effLatas36=cam.vol==='misto'?recPkg.n36:0;
      const variant36=cam.vol==='misto'?findVariant(p,'3.6L'):null;
      const price36=variant36?variant36.price/100:0;
      const subtotal=(price*effLatas)+(price36*effLatas36);
      h+=`<div class="prod-preview">`;
      h+=`<img src="${getProductImage(p)}" alt="${p.title}" loading="lazy">`;
      h+=`<div class="prod-info"><div class="prod-name">${p.title}</div><div class="prod-meta">${l.base} | Rend: ${rend} m²/L | DFT: ${l.dft||'N/D'}</div></div>`;
      h+=`<div class="prod-price">${fmt(subtotal)}</div>`;
      h+=`</div>`;

      /* Stats parciais */
      h+=`<div class="partial-result">`;
      h+=`<div class="partial-stat"><div class="ps-value">${litros.toFixed(1)} L</div><div class="ps-label">Consumo</div></div>`;
      if(cam.vol==='misto'){
        h+=`<div class="partial-stat"><div class="ps-value">${packDesc(recPkg)}</div><div class="ps-label">Recomendado</div></div>`;
        h+=`<div class="partial-stat"><div class="ps-value">${recPkg.waste.toFixed(1)} L</div><div class="ps-label">Sobra</div></div>`;
      }else{
        const qLatas=cam.vol==='18L'?latas:Math.ceil(litros/3.6);
        h+=`<div class="partial-stat"><div class="ps-value">${qLatas}x ${cam.vol}</div><div class="ps-label">Latas</div></div>`;
      }
      h+=`<div class="partial-stat"><div class="ps-value">${fmt(subtotal)}</div><div class="ps-label">Subtotal</div></div>`;
      h+=`</div>`;

      /* Link para produto */
      h+=`<div class="prod-link-row"><a class="link-btn" href="${searchUrl(cam.linha)}" target="_blank">Ver ${cam.linha} no site ${ICO.arrow}</a></div>`;

    }else if(cam.ral && !cam.product){
      h+=`<div class="prod-preview" style="justify-content:center"><span class="spinner"></span></div>`;
    }

    h+=`</div>`; /* /layer-card */
  });

  /* Add layer */
  if(state.camadas.length<3){
    h+=`<button class="add-layer" id="addLayer">${ICO.plus} Adicionar camada (${state.camadas.length}/3)</button>`;
  }

  /* Resumo */
  const camadasOk=state.camadas.filter(c=>c.ral&&c.product);
  if(camadasOk.length>0){
    h+=`<div class="sec-label mb-16">${ICO.receipt}<h2>Resumo do Orçamento</h2></div>`;
    h+=`<div class="summary">`;
    h+=`<div class="summary-header">${ICO.receipt} ${camadasOk.length} ${camadasOk.length===1?'produto':'produtos'} no orçamento</div>`;

    let total=0;
    const perdaRes=calcPerda(state.metodo,state.geometria);
    camadasOk.forEach((cam,ci)=>{
      const l=LINHAS[cam.linha];
      const rend=getRend(cam.linha,state.sub);
      const litros=(state.area/rend)*(1+perdaRes/100)*cam.dem;
      const pkgR=calcPackaging(litros);
      const recR=pkgR.find(o=>o.recommended)||pkgR[0];
      const volRef=cam.vol==='misto'?'18L':cam.vol;
      const lataCap=cam.vol==='18L'?18:3.6;
      const latas=cam.vol==='misto'?recR.n18:Math.ceil(litros/lataCap);
      const latas36=cam.vol==='misto'?recR.n36:0;
      const p=cam.product;
      const variant=findVariant(p,volRef);
      const variant36=cam.vol==='misto'?findVariant(p,'3.6L'):null;
      const price=variant?variant.price/100:0;
      const price36=variant36?variant36.price/100:0;
      const subtotal=(price*latas)+(price36*latas36);
      total+=subtotal;
      const vid=variant?variant.id:null;
      const vid36=variant36?variant36.id:null;
      const fbk=state.cartFeedback['p-'+ci];
      const sumDetail=cam.vol==='misto'?`${packDesc(recR)} | ${litros.toFixed(1)} L | ${cam.dem} ${cam.dem===1?'demão':'demãos'} | DFT: ${l.dft||'N/D'}`:`${latas}x ${cam.vol} | ${litros.toFixed(1)} L | ${cam.dem} ${cam.dem===1?'demão':'demãos'} | DFT: ${l.dft||'N/D'}`;

      h+=`<div class="sum-row">`;
      h+=`<img src="${getProductImage(p)}" alt="${p.title}" loading="lazy">`;
      h+=`<div class="sum-info"><div class="sum-name">Camada ${ci+1}: ${cam.linha}${cam.ral?' '+cam.ral:''}</div><div class="sum-detail">${sumDetail}</div></div>`;
      h+=`<div class="sum-price">${fmt(subtotal)}</div>`;
      h+=`<div class="sum-actions">`;
      if(fbk) h+=`<span class="cart-ok">${ICO.check} Adicionado</span>`;
      else if(vid) h+=`<button class="ot-btn-outline" data-cart-add="${vid}" data-cart-qty="${latas}" ${vid36&&latas36>0?`data-cart-add-36="${vid36}" data-cart-qty-36="${latas36}"`:''} data-cart-key="p-${ci}">${ICO.cart} Adicionar</button>`;
      h+=`</div></div>`;

      /* Upsell: diluente */
      if(l.dil){
        const dilFbk=state.cartFeedback['dil-'+ci];
        h+=`<div class="upsell-row">`;
        h+=`<img src="" alt="" data-upsell-img="${l.dil}" loading="lazy" style="background:var(--ot-surface)">`;
        h+=`<div class="upsell-info"><span class="upsell-badge">Recomendado</span><div class="upsell-name">${l.dilNome}</div></div>`;
        h+=`<div class="upsell-price" data-upsell-price="${l.dil}"></div>`;
        if(dilFbk) h+=`<span class="cart-ok">${ICO.check} OK</span>`;
        else h+=`<button class="ot-btn-ghost" data-cart-upsell="${l.dil}" data-cart-qty="1" data-cart-key="dil-${ci}">${ICO.plus} Adicionar</button>`;
        h+=`</div>`;
      }
    });

    h+=`<div class="sum-total"><div class="sum-total-label">Total estimado (tintas)</div><div class="sum-total-value">${fmt(total)}</div></div>`;
    h+=`</div>`;
    h+=`<button class="ot-btn full mb-24" id="addAll">${ICO.cart} Adicionar o pacote completo ao carrinho</button>`;
    h+=`<p class="disclaimer">Valores calculados com rendimento para substrato <strong>${state.sub}</strong>, método <strong>${state.metodo}</strong> e perda de <strong>${calcPerda(state.metodo,state.geometria)}%</strong>. Consumo real pode variar conforme preparo da superfície e condições ambientais.</p>`;
  }

  container.innerHTML=h;
  applyOtSwatchColors(container);
  bindOrcamentoEvents(container);
  loadUpsellData(container);
}

/* Events for Orçamento tab */
function bindOrcamentoEvents(ctx){
  /* Area */
  const areaInp=$('#otArea',ctx);
  if(areaInp){
    areaInp.addEventListener('change',e=>{
      const v=parseFloat(e.target.value);
      if(v>0&&v<=100000){state.area=v;renderShell();}
      else e.target.classList.add('invalid');
    });
  }

  /* Substrato */
  $$('.seg [data-sub]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{state.sub=btn.dataset.sub;renderShell();});
  });

  /* Método de aplicação */
  $$('[data-metodo]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{state.metodo=btn.dataset.metodo;renderShell();});
  });
  /* Geometria */
  $$('[data-geometria]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{state.geometria=btn.dataset.geometria;renderShell();});
  });

  /* Linha */
  $$('.chip[data-linha]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.layer;
      if(state.camadas[i].linha!==btn.dataset.linha){
        state.camadas[i].linha=btn.dataset.linha;
        state.camadas[i].ral='';
        state.camadas[i].product=null;
        renderShell();
      }
    });
  });

  /* RAL input */
  $$('[data-ral-input]',ctx).forEach(inp=>{
    const i=+inp.dataset.ralInput;
    const list=$(`[data-ral-list="${i}"]`,ctx);
    const rals=getRals(state.camadas[i].linha);
    const l=LINHAS[state.camadas[i].linha];

    let activeCat=null;
    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          if(l.ralLabels&&l.ralLabels[r]&&l.ralLabels[r].toLowerCase().includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      if(matches.length===0){
        list.innerHTML='<div class="ral-no-results">Nenhum código encontrado</div>';
        return;
      }
      list.innerHTML=matches.map(r=>{
        const label=l.ralLabels?l.ralLabels[r]:'RAL '+r;
        const name=l.ralLabels?'':` <span class="ral-name-hint">${ralName(r)}</span>`;
        return `<div class="ral-item" data-ral-pick="${r}" data-layer="${i}">${ralSwatch(r,18)}<span>${label}${name}</span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,state.camadas[i].linha,matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectRal(i,item.dataset.ralPick));
      });
    };

    inp.addEventListener('input',()=>showResults(inp.value.trim().toLowerCase()));
    inp.addEventListener('focus',()=>showResults(inp.value.trim().toLowerCase()));

    /* Category chips */
    $$(`[data-cat][data-layer="${i}"]`,ctx).forEach(chip=>{
      chip.addEventListener('click',()=>{
        activeCat=chip.dataset.cat==='all'?null:chip.dataset.cat;
        $$(`[data-cat][data-layer="${i}"]`,ctx).forEach(c=>c.classList.remove('active'));
        chip.classList.add('active');
        showResults(inp.value.trim().toLowerCase());
      });
    });
  });

  /* RAL clear */
  $$('[data-ral-clear]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.ralClear;
      state.camadas[i].ral='';
      state.camadas[i].product=null;
      renderShell();
    });
  });

  /* Demãos */
  $$('[data-dem]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.layer;
      state.camadas[i].dem=+btn.dataset.dem;
      renderShell();
    });
  });

  /* Volume */
  $$('.seg [data-vol]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.layer;
      state.camadas[i].vol=btn.dataset.vol;
      renderShell();
    });
  });

  /* Remove layer */
  $$('[data-remove]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      state.camadas.splice(+btn.dataset.remove,1);
      renderShell();
    });
  });

  /* Add layer */
  const addBtn=$('#addLayer',ctx);
  if(addBtn){
    addBtn.addEventListener('click',()=>{
      if(state.camadas.length<3){
        state.camadas.push({linha:'TMED',ral:'',dem:2,vol:'misto',product:null});
        renderShell();
      }
    });
  }

  /* Cart: individual (suporta misto com 18L+3.6L) */
  $$('[data-cart-add]',ctx).forEach(btn=>{
    btn.addEventListener('click',async()=>{
      btn.disabled=true;btn.innerHTML='<span class="spinner"></span>';
      const items=[];
      const mainId=Number(btn.dataset.cartAdd);
      const mainQty=Number(btn.dataset.cartQty||1);
      if(mainId&&!isNaN(mainId)&&mainQty>0) items.push({id:mainId,quantity:mainQty});
      if(btn.dataset.cartAdd36){
        const id36=Number(btn.dataset.cartAdd36);
        const qty36=Number(btn.dataset.cartQty36);
        if(id36&&!isNaN(id36)&&qty36>0) items.push({id:id36,quantity:qty36});
      }
      if(items.length===0){btn.innerHTML='Variante indisponível';btn.disabled=false;return;}
      const ok=items.length>1?await addMultipleToCart(items):await addToCart(items[0].id,items[0].quantity);
      if(ok){state.cartFeedback[btn.dataset.cartKey]=true;refreshCartUI();renderShell();}
      else{btn.innerHTML='Erro: variante indisponível';btn.disabled=false;}
    });
  });

  /* Cart: upsell (catalisador/diluente) */
  $$('[data-cart-upsell]',ctx).forEach(btn=>{
    btn.addEventListener('click',async()=>{
      btn.disabled=true;btn.innerHTML='<span class="spinner"></span>';
      const p=await fetchProduct(btn.dataset.cartUpsell);
      if(p){
        const v=findVariant(p,'5L');
        if(v){
          const ok=await addToCart(v.id,btn.dataset.cartQty);
          if(ok){state.cartFeedback[btn.dataset.cartKey]=true;refreshCartUI();renderShell();return;}
        }
      }
      btn.innerHTML='Produto não encontrado';btn.disabled=false;
    });
  });

  /* Cart: add all */
  const addAllBtn=$('#addAll',ctx);
  if(addAllBtn){
    addAllBtn.addEventListener('click',async()=>{
      addAllBtn.disabled=true;addAllBtn.innerHTML='<span class="spinner"></span> Adicionando...';
      const items=[];
      const perdaAll=calcPerda(state.metodo,state.geometria);
      state.camadas.filter(c=>c.ral&&c.product).forEach(cam=>{
        const rend=getRend(cam.linha,state.sub);
        const litros=(state.area/rend)*(1+perdaAll/100)*cam.dem;
        if(cam.vol==='misto'){
          const pkg=calcPackaging(litros);const rec=pkg.find(o=>o.recommended)||pkg[0];
          if(rec.n18>0){const v=findVariant(cam.product,'18L');if(v) items.push({id:v.id,quantity:rec.n18});}
          if(rec.n36>0){const v=findVariant(cam.product,'3.6L');if(v) items.push({id:v.id,quantity:rec.n36});}
        }else{
          const lataCap=cam.vol==='18L'?18:3.6;
          const latas=Math.ceil(litros/lataCap);
          const variant=findVariant(cam.product,cam.vol);
          if(variant) items.push({id:variant.id,quantity:latas});
        }
      });
      if(items.length>0){
        const ok=await addMultipleToCart(items);
        if(ok){
          state.camadas.forEach((_,ci)=>{state.cartFeedback['p-'+ci]=true;});
          refreshCartUI();
          renderShell();return;
        }
      }
      addAllBtn.innerHTML='Erro ao adicionar';addAllBtn.disabled=false;
    });
  }
}

/* RAL selection */
async function selectRal(layerIdx,ral){
  state.camadas[layerIdx].ral=ral;
  state.camadas[layerIdx].product=null;
  renderShell();
  const handle=getHandle(state.camadas[layerIdx].linha,ral);
  if(!handle) return;
  const product=await fetchProduct(handle);
  if(product){
    state.camadas[layerIdx].product=product;
    renderShell();
  }
}

/* Load upsell images & prices */
async function loadUpsellData(ctx){
  const imgs=$$('[data-upsell-img]',ctx);
  const prices=$$('[data-upsell-price]',ctx);
  const handles=new Set();
  imgs.forEach(img=>handles.add(img.dataset.upsellImg));
  prices.forEach(el=>handles.add(el.dataset.upsellPrice));
  for(const h of handles){
    const p=await fetchProduct(h);
    if(!p) continue;
    const imgUrl=getColorImage(p);
    const v=findVariant(p,'5L');
    const price=v?v.price/100:0;
    $$(`[data-upsell-img="${h}"]`,ctx).forEach(img=>{img.src=imgUrl;img.alt=p.title;});
    $$(`[data-upsell-price="${h}"]`,ctx).forEach(span=>{span.textContent=fmt(price);});
  }
}

/* ═══════════════════════════════════════════════════════════
   TAB 2: ISO 12944 - Corrosivos ─── */
const isoState={sel:'C3',area:200,metodo:'rolo',geometria:'planas',sub:'medio',ral:'',vol:'misto',products:[],cartFeedback:{}};

/* Events for ISO cart integration */
async function bindISOCartEvents(ctx){
  /* Area */
  const areaInp=$('#isoArea',ctx);
  if(areaInp){
    areaInp.addEventListener('change',e=>{
      const v=parseFloat(e.target.value);
      if(v>0&&v<=100000){isoState.area=v;isoState.cartFeedback={};renderShell();}
      else e.target.classList.add('invalid');
    });
  }

  /* Substrato */
  $$('[data-iso-sub]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{isoState.sub=btn.dataset.isoSub;isoState.cartFeedback={};renderShell();});
  });

  /* Método */
  $$('[data-iso-metodo]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{isoState.metodo=btn.dataset.isoMetodo;isoState.cartFeedback={};renderShell();});
  });
  /* Geometria */
  $$('[data-iso-geometria]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{isoState.geometria=btn.dataset.isoGeometria;isoState.cartFeedback={};renderShell();});
  });

  /* RAL input */
  const ralInp=$('#isoRalInput',ctx);
  if(ralInp){
    const list=$('#isoRalList',ctx);
    const rals=RAL_FULL;
    let activeCat=null;

    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      if(matches.length===0){
        list.innerHTML='<div class="ral-no-results">Nenhum código encontrado</div>';
        return;
      }
      list.innerHTML=matches.map(r=>{
        return `<div class="ral-item" data-iso-ral-pick="${r}">${ralSwatch(r,18)}<span>RAL ${r} <span class="ral-name-hint">${ralName(r)}</span></span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,'TMSR',matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectIsoRal(item.dataset.isoRalPick));
      });
    };

    ralInp.addEventListener('input',()=>showResults(ralInp.value.trim().toLowerCase()));
    ralInp.addEventListener('focus',()=>showResults(ralInp.value.trim().toLowerCase()));

    /* Category chips */
    $$('[data-iso-cat]',ctx).forEach(chip=>{
      chip.addEventListener('click',()=>{
        activeCat=chip.dataset.isoCat==='all'?null:chip.dataset.isoCat;
        $$('[data-iso-cat]',ctx).forEach(c=>c.classList.remove('active'));
        chip.classList.add('active');
        showResults(ralInp.value.trim().toLowerCase());
      });
    });
  }

  /* RAL clear */
  const clearBtn=$('#isoClearRal',ctx);
  if(clearBtn){
    clearBtn.addEventListener('click',()=>{
      isoState.ral='';
      isoState.products=[];
      renderShell();
    });
  }

  /* Volume */
  $$('[data-iso-vol]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      isoState.vol=btn.dataset.isoVol;
      isoState.cartFeedback={};
      renderShell();
    });
  });

  /* Cart: individual ISO products */
  $$('[data-iso-cart-add]',ctx).forEach(btn=>{
    btn.addEventListener('click',async()=>{
      btn.disabled=true;btn.innerHTML='<span class="spinner"></span>';
      const items=[];
      const isoId=+btn.dataset.isoCartAdd;
      if(isoId&&!isNaN(isoId)&&+btn.dataset.isoCartQty>0) items.push({id:isoId,quantity:+btn.dataset.isoCartQty});
      const isoId36=+btn.dataset.isoCartAdd36;
      if(isoId36&&!isNaN(isoId36)&&+btn.dataset.isoCartQty36>0) items.push({id:isoId36,quantity:+btn.dataset.isoCartQty36});
      if(items.length===0){btn.innerHTML='Variante indisponível';btn.disabled=false;return;}
      const ok=items.length===1?await addToCart(items[0].id,items[0].quantity):await addMultipleToCart(items);
      if(ok){isoState.cartFeedback[btn.dataset.isoCartKey]=true;refreshCartUI();renderShell();}
      else{btn.innerHTML='Erro';btn.disabled=false;}
    });
  });

  /* Cart: add all ISO products */
  const addAllBtn=$('#isoAddAllCart',ctx);
  if(addAllBtn){
    addAllBtn.addEventListener('click',async()=>{
      addAllBtn.disabled=true;addAllBtn.innerHTML='<span class="spinner"></span> Adicionando...';
      const perdaAll=calcPerda(isoState.metodo,isoState.geometria);
      const items=[];
      isoState.products.forEach((prod,pi)=>{
        const rend=getRend(prod.linha,isoState.sub);
        const litros=(isoState.area/rend)*(1+perdaAll/100)*prod.dem;
        if(isoState.vol==='misto'){
          const pkg=calcPackaging(litros);
          const rec=pkg.find(o=>o.recommended)||pkg[0];
          const v18=findVariant(prod.product,'18L');
          const v36=findVariant(prod.product,'3.6L');
          if(v18&&rec.n18>0) items.push({id:v18.id,quantity:rec.n18});
          if(v36&&rec.n36>0) items.push({id:v36.id,quantity:rec.n36});
        }else{
          const lataCap=isoState.vol==='18L'?18:3.6;
          const latas=Math.ceil(litros/lataCap);
          const variant=findVariant(prod.product,isoState.vol);
          if(variant) items.push({id:variant.id,quantity:latas});
        }
      });
      if(items.length>0){
        const ok=await addMultipleToCart(items);
        if(ok){
          isoState.products.forEach((_,pi)=>{isoState.cartFeedback['iso-'+pi]=true;});
          refreshCartUI();
          renderShell();
        }else{addAllBtn.innerHTML='Erro ao adicionar';addAllBtn.disabled=false;}
      }
    });
  }
}

/* RAL selection for ISO tab */
async function selectIsoRal(ral){
  isoState.ral=ral;
  isoState.products=[];
  renderShell();

  const sy=ISO[isoState.sel];
  if(!sy||!sy.s) return;

  for(const layer of sy.s){
    const handle=getHandle(layer.p,ral);
    if(!handle) continue;
    const product=await fetchProduct(handle);
    if(product){
      isoState.products.push({linha:layer.p,product:product,dem:1});
    }
  }
  renderShell();
}

/* ═══════════════════════════════════════════════════════════
   TAB 2: ISO 12944
   ═══════════════════════════════════════════════════════════ */

function renderISO(container){
  const s=isoState;
  const sy=ISO[s.sel];

  let h=`<p style="color:var(--ot-sub);font-size:15px;line-height:1.7;margin-bottom:28px">Selecione a categoria de corrosividade (ISO 12944) para obter o sistema de pintura recomendado.</p>`;

  h+=`<div class="chip-group mb-28" role="radiogroup">`;
  Object.entries(ISO).forEach(([k,v])=>{
    const isActive=s.sel===k;
    h+=`<button class="chip ${isActive?'active':''}" data-iso="${k}" style="${isActive?`border-color:${v.cor};background:${v.cor}0A;color:${v.cor}`:''}">
      <div style="display:flex;flex-direction:column;align-items:center;gap:2px">
        <span style="font-weight:800;font-size:18px;line-height:1">${k}</span>
        <span style="font-size:11px;font-weight:400;color:${isActive?v.cor:'var(--ot-muted)'}">${v.sl}</span>
      </div>
    </button>`;
  });
  h+=`</div>`;

  h+=`<div class="bento mb-12" style="display:flex;align-items:center;gap:16px">
    <div style="width:56px;height:56px;border-radius:16px;background:${sy.cor}0C;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:800;color:${sy.cor};flex-shrink:0;border:1.5px solid ${sy.cor}20">${s.sel}</div>
    <div>
      <div style="font-weight:700;font-size:19px;letter-spacing:-.02em;line-height:1.2">Corrosividade ${sy.sl}</div>
      <div style="color:var(--ot-sub);font-size:14px;margin-top:4px;line-height:1.4">${sy.d}</div>
    </div>
  </div>`;

  h+=`<div class="grid-2 mb-20">${makeStat('DFT Total Recomendado',sy.dft,sy.cor,ICO.layers)}${makeStat('Camadas',sy.cam,null,ICO.layers)}</div>`;

  h+=`<div class="sec-label">${ICO.layers}<h3>Sistema Recomendado</h3></div>`;
  h+=`<div style="margin-bottom:16px">`;
  sy.s.forEach((cm,i)=>{
    const pr=LINHAS[cm.p];
    h+=`${i>0?'<div class="layer-divider"></div>':''}
      <div class="layer-step">
        <div class="layer-num" style="background:${sy.cor}12;color:${sy.cor};border:1.5px solid ${sy.cor}30">${i+1}</div>
        <div class="layer-info">
          <div class="layer-title">${cm.f}</div>
          <div class="layer-detail">${cm.p} | Rend: ${pr.rM}-${pr.rX} m²/L | DFT: ${pr.dft||'N/D'}</div>
        </div>
        <a class="link-btn layer-link" href="${searchUrl(cm.p)}" target="_blank" style="font-size:13px">Ver ${cm.p} ${ICO.arrow}</a>
      </div>`;
  });
  h+=`</div>`;

  h+=`<div class="info-box" style="background:var(--ot-accent-soft)">
    <span style="color:var(--ot-accent);flex-shrink:0">${ICO.info}</span>
    <span>Para projetos C5 ou agentes químicos específicos: <a href="${B}/pages/contato" target="_blank" style="font-weight:700">fale com nossa equipe</a></span>
  </div>`;

  /* Montar Este Sistema */
  h+=`<div class="sec-label mb-16">${ICO.layers}<h2>Montar Este Sistema</h2></div>`;

  /* Area + Método + Geometria */
  h+=`<div class="bento mb-24">`;
  h+=`<div class="grid-2">`;
  h+=`<div class="field"><label>Área total</label><div class="field-wrap"><input type="number" id="isoArea" value="${isoState.area}" min="1" max="100000" inputmode="numeric" class="has-unit"><span class="unit">m²</span></div></div>`;
  h+=`<div class="field"><label>Tipo de substrato</label><div class="seg" role="radiogroup">`;
  ['liso','medio','rugoso'].forEach(s=>{
    h+=`<button class="${isoState.sub===s?'active':''}" data-iso-sub="${s}">${s.charAt(0).toUpperCase()+s.slice(1)}</button>`;
  });
  h+=`</div></div>`;
  h+=`</div>`;

  /* Método de aplicação + geometria */
  h+=`<div class="field mt-16"><label>Método de aplicação</label><div class="seg" role="radiogroup">`;
  ['rolo','pistola'].forEach(m=>{
    h+=`<button class="${isoState.metodo===m?'active':''}" data-iso-metodo="${m}">${m==='rolo'?'Rolo':'Pistola'}</button>`;
  });
  h+=`</div></div>`;
  if(isoState.metodo==='pistola'){
    h+=`<div class="field mt-16"><label>Geometria da superfície</label><div class="seg" role="radiogroup">`;
    [['planas','Superfícies planas'],['perfis','Perfis e estruturas'],['grades','Grades e treliças']].forEach(([k,v])=>{
      h+=`<button class="${isoState.geometria===k?'active':''}" data-iso-geometria="${k}">${v}</button>`;
    });
    h+=`</div></div>`;
  }
  const _isoPerd=calcPerda(isoState.metodo,isoState.geometria);
  h+=`<div style="display:flex;align-items:center;gap:8px;padding:10px 14px;background:var(--ot-accent-soft);border-radius:10px;margin-top:12px;font-size:13px;font-weight:500;color:var(--ot-accent)">${ICO.info} Perda estimada: ${_isoPerd}%</div>`;
  h+=`</div>`;

  /* RAL picker */
  h+=`<div class="sec-label mb-16">${ICO.drop}<h3>Selecione a Cor</h3></div>`;
  if(!isoState.ral){
    h+=`<div class="ral-search">`;
    h+=`<div class="ral-cat-bar">`;
    RAL_CATS.forEach(cat=>{
      h+=`<button class="ral-cat-chip" data-iso-cat="${cat.prefix}"><span style="width:12px;height:12px;background:${cat.cor};border-radius:3px;display:inline-block;flex-shrink:0"></span> ${cat.label}</button>`;
    });
    h+=`<button class="ral-cat-chip" data-iso-cat="all">Todas</button>`;
    h+=`</div>`;
    h+=`<div class="ral-search-wrap"><span class="ral-search-icon">${ICO.search}</span>`;
    h+=`<input type="text" class="ral-search-input" id="isoRalInput" placeholder="Buscar RAL (ex: 7035, cinza, grey...)" autocomplete="off"></div>`;
    h+=`<div class="ral-results" id="isoRalList"></div></div>`;
  }else{
    h+=`<div class="ral-selected">${ralSwatch(isoState.ral,20)}<span>RAL ${isoState.ral} ${ralName(isoState.ral)}</span><button class="ral-clear" id="isoClearRal">Trocar</button></div>`;
  }

  /* Volume selector */
  h+=`<div class="sec-label mb-16 mt-24">${ICO.bucket}<h3>Volume da Lata</h3></div>`;
  h+=`<div class="seg mb-24" role="radiogroup">`;
  ['3.6L','18L','misto'].forEach(v=>{
    h+=`<button class="${isoState.vol===v?'active':''}" data-iso-vol="${v}">${v==='misto'?'Misto (menos sobra)':v}</button>`;
  });
  h+=`</div>`;

  /* Product previews */
  const perdaIso=calcPerda(isoState.metodo,isoState.geometria);
  if(isoState.ral && isoState.products.length>0){
    h+=`<div class="sec-label mb-16">${ICO.layers}<h3>Produtos do Sistema</h3></div>`;
    h+=`<div style="display:flex;flex-direction:column;gap:12px;margin-bottom:24px">`;
    let total=0;
    isoState.products.forEach((prod,pi)=>{
      const l=LINHAS[prod.linha];
      const rend=getRend(prod.linha,isoState.sub);
      const litros=(isoState.area/rend)*(1+perdaIso/100)*prod.dem;

      if(isoState.vol==='misto'){
        const pkg=calcPackaging(litros);
        const rec=pkg.find(o=>o.recommended)||pkg[0];
        const v18=findVariant(prod.product,'18L');
        const v36=findVariant(prod.product,'3.6L');
        const p18=v18?v18.price/100:0;
        const p36=v36?v36.price/100:0;
        const subtotal=(rec.n18*p18)+(rec.n36*p36);
        total+=subtotal;
        const fbk=isoState.cartFeedback['iso-'+pi];

        h+=`<div class="prod-preview">`;
        h+=`<img src="${getProductImage(prod.product)}" alt="${prod.product.title}" loading="lazy">`;
        h+=`<div class="prod-info"><div class="prod-name">${prod.product.title}</div><div class="prod-meta">${l.base} | Rend: ${rend} m²/L | ${packDesc(rec)}</div></div>`;
        h+=`<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">`;
        h+=`<div class="prod-price">${fmt(subtotal)}</div>`;
        if(fbk) h+=`<span class="cart-ok">${ICO.check} Adicionado</span>`;
        else{
          const vid18=v18?v18.id:null;const vid36=v36?v36.id:null;
          if(vid18||vid36) h+=`<button class="ot-btn-outline" data-iso-cart-add="${vid18||''}" data-iso-cart-qty="${rec.n18}" data-iso-cart-add-36="${vid36||''}" data-iso-cart-qty-36="${rec.n36}" data-iso-cart-key="iso-${pi}">${ICO.cart} Adicionar</button>`;
        }
        h+=`</div></div>`;
      }else{
        const lataCap=isoState.vol==='18L'?18:3.6;
        const latas=Math.ceil(litros/lataCap);
        const variant=findVariant(prod.product,isoState.vol);
        const price=variant?variant.price/100:0;
        const subtotal=price*latas;
        total+=subtotal;
        const vid=variant?variant.id:null;
        const fbk=isoState.cartFeedback['iso-'+pi];

        h+=`<div class="prod-preview">`;
        h+=`<img src="${getProductImage(prod.product)}" alt="${prod.product.title}" loading="lazy">`;
        h+=`<div class="prod-info"><div class="prod-name">${prod.product.title}</div><div class="prod-meta">${l.base} | Rend: ${rend} m²/L | ${latas}x ${isoState.vol}</div></div>`;
        h+=`<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">`;
        h+=`<div class="prod-price">${fmt(subtotal)}</div>`;
        if(fbk) h+=`<span class="cart-ok">${ICO.check} Adicionado</span>`;
        else if(vid) h+=`<button class="ot-btn-outline" data-iso-cart-add="${vid}" data-iso-cart-qty="${latas}" data-iso-cart-key="iso-${pi}">${ICO.cart} Adicionar</button>`;
        h+=`</div></div>`;
      }
    });

    h+=`<div class="summary" style="margin-top:16px">`;
    h+=`<div class="sum-total"><div class="sum-total-label">Total estimado</div><div class="sum-total-value">${fmt(total)}</div></div>`;
    h+=`</div>`;
    const allAdded=isoState.products.every((_,pi)=>isoState.cartFeedback['iso-'+pi]);
    if(allAdded){
      h+=`<div style="text-align:center;margin-top:12px"><span class="cart-ok" style="font-size:15px">${ICO.check} Todos adicionados ao carrinho</span></div>`;
    }else{
      h+=`<button class="ot-btn full mt-12" id="isoAddAllCart">${ICO.cart} Adicionar tudo ao carrinho</button>`;
    }
    h+=`</div>`;
  }else if(isoState.ral && isoState.products.length===0){
    h+=`<div style="text-align:center;padding:32px 0"><span class="spinner"></span></div>`;
  }

  h+=makeFontes(['ISO 12944:2018 (Paints and varnishes)','Boletins Técnicos Eurolatina']);
  h+=makeDisclaimer();

  container.innerHTML=h;
  applyOtSwatchColors(container);
  $$('.chip[data-iso]',container).forEach(c=>c.addEventListener('click',()=>{isoState.sel=c.dataset.iso;renderShell();}));
  bindISOCartEvents(container);
}

/* ═══════════════════════════════════════════════════════════
   TAB 3: COMPARATIVO
   ═══════════════════════════════════════════════════════════ */
const compState={sel:['TMSR','TMED','TMER','TPUR'],viewLine:null,viewRal:'',viewProduct:null,viewVol:'18L',cartFbk:null};

/* Events for Comparativo product view */
async function bindCompViewEvents(ctx){
  $$('[data-comp-view]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      compState.viewLine=btn.dataset.compView;
      compState.viewRal='';
      compState.viewProduct=null;
      compState.cartFbk=null;
      renderShell();
    });
  });

  const ralInp=$('#compRalInput',ctx);
  if(ralInp){
    const list=$('#compRalList',ctx);
    const l=LINHAS[compState.viewLine];
    const rals=getRals(compState.viewLine);
    let activeCat=null;

    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          if(l.ralLabels&&l.ralLabels[r]&&l.ralLabels[r].toLowerCase().includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      if(matches.length===0){
        list.innerHTML='<div class="ral-no-results">Nenhum código encontrado</div>';
        return;
      }
      list.innerHTML=matches.map(r=>{
        const label=l.ralLabels?l.ralLabels[r]:'RAL '+r;
        const name=l.ralLabels?'':` <span class="ral-name-hint">${ralName(r)}</span>`;
        return `<div class="ral-item" data-comp-ral-pick="${r}">${ralSwatch(r,18)}<span>${label}${name}</span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,compState.viewLine,matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectCompRal(item.dataset.compRalPick));
      });
    };

    ralInp.addEventListener('input',()=>showResults(ralInp.value.trim().toLowerCase()));
    ralInp.addEventListener('focus',()=>showResults(ralInp.value.trim().toLowerCase()));

    $$('[data-comp-cat]',ctx).forEach(chip=>{
      chip.addEventListener('click',()=>{
        activeCat=chip.dataset.compCat==='all'?null:chip.dataset.compCat;
        $$('[data-comp-cat]',ctx).forEach(c=>c.classList.remove('active'));
        chip.classList.add('active');
        showResults(ralInp.value.trim().toLowerCase());
      });
    });
  }

  const clearBtn=$('#compClearRal',ctx);
  if(clearBtn){
    clearBtn.addEventListener('click',()=>{
      compState.viewRal='';
      compState.viewProduct=null;
      renderShell();
    });
  }

  $$('[data-comp-vol]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      compState.viewVol=btn.dataset.compVol;
      renderShell();
    });
  });

  const addBtn=$('#compAddCart',ctx);
  if(addBtn){
    addBtn.addEventListener('click',async()=>{
      addBtn.disabled=true;addBtn.innerHTML='<span class="spinner"></span>';
      const variant=findVariant(compState.viewProduct,compState.viewVol);
      if(variant){
        const ok=await addToCart(variant.id,1);
        if(ok){compState.cartFbk=true;refreshCartUI();renderShell();return;}
      }
      addBtn.innerHTML='Erro: variante indisponível';addBtn.disabled=false;
    });
  }
}

/* RAL selection for Comparativo */
async function selectCompRal(ral){
  compState.viewRal=ral;
  compState.viewProduct=null;
  renderShell();

  const handle=getHandle(compState.viewLine,ral);
  if(!handle) return;
  const product=await fetchProduct(handle);
  if(product){
    compState.viewProduct=product;
    renderShell();
  }
}

function renderComp(container){
  const rows=[
    {l:'Composição',k:'comp'},{l:'Rendimento',fn:l=>`${l.rM}-${l.rX} m²/L`},{l:'DFT/demão',k:'dft'},
    {l:'Sólidos',k:'sol',nil:'N/D'},{l:'Catalisador',fn:l=>l.cat?l.catNome:'Monocomponente'},
    {l:'Ambiente ISO',k:'amb',nil:'N/D'},{l:'Temp. máx.',k:'temp',nil:'N/D'},
    {l:'Pot-life',k:'potLife',nil:'N/A'},{l:'Secagem toque',k:'secT',nil:'N/D'},
    {l:'Secagem final',k:'secF',nil:'N/D'},{l:'Diluente',k:'dilNome',nil:'N/D'}
  ];

  let h=`<p style="color:var(--ot-sub);font-size:15px;line-height:1.7;margin-bottom:24px">Compare especificações técnicas lado a lado. Mínimo 2 produtos.</p>`;

  h+=`<div class="chip-group mb-24" role="group">`;
  Object.entries(LINHAS).forEach(([k,v])=>{
    h+=`<button class="chip ${compState.sel.includes(k)?'active':''}" data-comp="${k}">${k}<span class="chip-sub">${v.nome}</span></button>`;
  });
  h+=`</div>`;

  h+=`<div class="comp-table-wrap" style="position:relative">`;
  h+=`<button class="ot-scroll-arrow left comp-scroll-left">${ARROW_LEFT}</button>`;
  h+=`<button class="ot-scroll-arrow right comp-scroll-right">${ARROW_RIGHT}</button>`;
  h+=`<div class="comp-table-scroll"><table class="comp-table">`;
  h+=`<thead><tr><th>Especificação</th>`;
  compState.sel.forEach(k=>{
    h+=`<th class="prod"><div style="color:var(--ot-accent);font-weight:700;font-size:15px">${k}</div><div style="color:var(--ot-muted);font-size:11px;font-weight:400;margin-top:2px">${LINHAS[k].nome}</div></th>`;
  });
  h+=`</tr></thead><tbody>`;
  rows.forEach(r=>{
    h+=`<tr><td style="font-weight:500">${r.l}</td>`;
    compState.sel.forEach(k=>{
      const l=LINHAS[k];
      let v;
      if(r.fn) v=r.fn(l);
      else v=l[r.k]||r.nil||'N/A';
      const warn=typeof v==='string'&&(v.includes('N/')||v==='Monocomponente');
      h+=`<td style="color:${warn?'var(--ot-amber)':'var(--ot-text)'}">${v}</td>`;
    });
    h+=`</tr>`;
  });
  h+=`</tbody></table></div></div>`;

  /* Conhecer Produto */
  h+=`<div class="sec-label mb-16 mt-24">${ICO.layers}<h2>Conhecer Produto</h2></div>`;
  h+=`<div class="chip-group mb-24" role="group">`;
  compState.sel.forEach(k=>{
    h+=`<button class="chip ${compState.viewLine===k?'active':''}" data-comp-view="${k}">${k}</button>`;
  });
  h+=`</div>`;

  if(compState.viewLine){
    const l=LINHAS[compState.viewLine];
    const rals=getRals(compState.viewLine);

    if(!compState.viewRal){
      h+=`<div class="ral-search">`;
      h+=`<div class="ral-cat-bar">`;
      RAL_CATS.forEach(cat=>{
        const catRals=rals.filter(r=>r.startsWith(cat.prefix));
        if(catRals.length>0){
          h+=`<button class="ral-cat-chip" data-comp-cat="${cat.prefix}"><span style="width:12px;height:12px;background:${cat.cor};border-radius:3px;display:inline-block;flex-shrink:0"></span> ${cat.label}</button>`;
        }
      });
      h+=`<button class="ral-cat-chip" data-comp-cat="all">Todas</button>`;
      h+=`</div>`;
      h+=`<div class="ral-search-wrap"><span class="ral-search-icon">${ICO.search}</span>`;
      h+=`<input type="text" class="ral-search-input" id="compRalInput" placeholder="${l.ralLabels?'Selecione a cor':'Buscar RAL (ex: 7035, cinza, grey...)'}" autocomplete="off"></div>`;
      h+=`<div class="ral-results" id="compRalList"></div></div>`;
    }else if(compState.viewProduct){
      const p=compState.viewProduct;
      const variant=findVariant(p,compState.viewVol);
      const price=variant?variant.price/100:0;

      h+=`<div class="ral-selected">${ralSwatch(compState.viewRal,20)}<span>${l.ralLabels?l.ralLabels[compState.viewRal]:'RAL '+compState.viewRal} ${l.ralLabels?'':ralName(compState.viewRal)}</span><button class="ral-clear" id="compClearRal">Trocar</button></div>`;

      h+=`<div class="prod-preview">`;
      h+=`<img src="${getProductImage(p)}" alt="${p.title}" loading="lazy">`;
      h+=`<div class="prod-info"><div class="prod-name">${p.title}</div><div class="prod-meta">${l.base} | Rend: ${l.rM}-${l.rX} m²/L | DFT: ${l.dft||'N/D'}</div></div>`;
      h+=`<div class="prod-price">${fmt(price)}</div>`;
      h+=`</div>`;

      h+=`<div class="sec-label mb-16">${ICO.bucket}<h3>Volume da Lata</h3></div>`;
      h+=`<div class="seg mb-24" role="radiogroup">`;
      ['3.6L','18L'].forEach(v=>{
        h+=`<button class="${compState.viewVol===v?'active':''}" data-comp-vol="${v}">${v}</button>`;
      });
      h+=`</div>`;

      if(compState.cartFbk) h+=`<span class="cart-ok mb-24">${ICO.check} Adicionado</span>`;
      else if(variant) h+=`<button class="ot-btn full mb-24" id="compAddCart">${ICO.cart} Adicionar ao carrinho</button>`;
    }else{
      h+=`<div style="text-align:center;padding:32px 0"><span class="spinner"></span></div>`;
    }
  }

  h+=makeFontes(['Boletins Técnicos Eurolatina','ISO 12944:2018']);
  h+=makeDisclaimer();

  container.innerHTML=h;
  applyOtSwatchColors(container);

  /* Scroll arrows for comp table */
  addScrollArrows('.comp-table-wrap','.comp-table-scroll',container);

  $$('.chip[data-comp]',container).forEach(c=>c.addEventListener('click',()=>{
    const k=c.dataset.comp;
    if(compState.sel.includes(k)){if(compState.sel.length>2) compState.sel=compState.sel.filter(x=>x!==k);}
    else compState.sel=[...compState.sel,k];
    renderShell();
  }));
  bindCompViewEvents(container);
}

/* ═══════════════════════════════════════════════════════════
   TAB 4: ROI
   ═══════════════════════════════════════════════════════════ */
const roiState={tipo:'metal',a:500,h:15,cc:70,ca:180,dc:3,da:15,cp:50000,cm:18000,prepA:40,prepI:10,advOpen:false,ral:'',roiProducts:[],roiVol:'18L',roiCartFbk:{}};

/* Events for ROI cart integration */
async function bindROICartEvents(ctx){
  const ralInp=$('#roiRalInput',ctx);
  if(ralInp){
    const list=$('#roiRalList',ctx);
    const rec=roiState.tipo==='metal'?['TMER','TPUR']:['EXA','ECR'];
    const rals=rec.reduce((acc, linha) => {
      const lr = getRals(linha);
      return acc ? acc.filter(r => lr.includes(r)) : [...lr];
    }, null) || RAL_FULL;
    let activeCat=null;

    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      if(matches.length===0){
        list.innerHTML='<div class="ral-no-results">Nenhum código encontrado</div>';
        return;
      }
      list.innerHTML=matches.map(r=>{
        return `<div class="ral-item" data-roi-ral-pick="${r}">${ralSwatch(r,18)}<span>RAL ${r} <span class="ral-name-hint">${ralName(r)}</span></span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,rec[0],matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectRoiRal(item.dataset.roiRalPick));
      });
    };

    ralInp.addEventListener('input',()=>showResults(ralInp.value.trim().toLowerCase()));
    ralInp.addEventListener('focus',()=>showResults(ralInp.value.trim().toLowerCase()));

    $$('[data-roi-cat]',ctx).forEach(chip=>{
      chip.addEventListener('click',()=>{
        activeCat=chip.dataset.roiCat==='all'?null:chip.dataset.roiCat;
        $$('[data-roi-cat]',ctx).forEach(c=>c.classList.remove('active'));
        chip.classList.add('active');
        showResults(ralInp.value.trim().toLowerCase());
      });
    });
  }

  const clearBtn=$('#roiClearRal',ctx);
  if(clearBtn){
    clearBtn.addEventListener('click',()=>{
      roiState.ral='';
      roiState.roiProducts=[];
      renderShell();
    });
  }

  $$('[data-roi-vol]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      roiState.roiVol=btn.dataset.roiVol;
      renderShell();
    });
  });

  $$('[data-roi-cart-add]',ctx).forEach(btn=>{
    btn.addEventListener('click',async()=>{
      btn.disabled=true;btn.innerHTML='<span class="spinner"></span>';
      const ok=await addToCart(btn.dataset.roiCartAdd,1);
      if(ok){roiState.roiCartFbk[btn.dataset.roiCartKey]=true;refreshCartUI();renderShell();}
      else{btn.innerHTML='Erro';btn.disabled=false;}
    });
  });
}

/* RAL selection for ROI */
async function selectRoiRal(ral){
  roiState.ral=ral;
  roiState.roiProducts=[];
  renderShell();

  const rec=roiState.tipo==='metal'?['TMER','TPUR']:['EXA','ECR'];
  for(const linha of rec){
    const handle=getHandle(linha,ral);
    if(!handle) continue;
    const product=await fetchProduct(handle);
    if(product){
      roiState.roiProducts.push({linha:linha,product:product});
    }
  }
  renderShell();
}

function renderROI(container){
  const s=roiState;
  const rInad=Math.floor(s.h/s.dc);
  const rAdeq=Math.max(0,Math.floor(s.h/s.da)-(s.da>=s.h?1:0));
  const ciInad=s.a*s.cc,ciAdeq=s.a*s.ca,cpInad=s.a*s.prepI,cpAdeq=s.a*s.prepA;
  const tcoInad=ciInad+cpInad+(rInad*(ciInad+cpInad+s.cp));
  const tcoAdeq=ciAdeq+cpAdeq+(rAdeq*s.cm);
  const eco=tcoInad-tcoAdeq;
  const roiPct=ciAdeq>0?((eco/(ciAdeq+cpAdeq))*100):0;
  const mx=Math.max(tcoInad,tcoAdeq,1);

  let inadT=ciInad+cpInad,adeqT=ciAdeq+cpAdeq;
  const inadC=[{y:0,v:inadT}],adeqC=[{y:0,v:adeqT}];
  for(let y=1;y<=s.h;y++){
    if(y%s.dc===0)inadT+=ciInad+cpInad+s.cp;
    if(s.da>0&&y%s.da===0&&y<s.h)adeqT+=s.cm;
    inadC.push({y,v:inadT});adeqC.push({y,v:adeqT});
  }
  const maxC=Math.max(inadC[inadC.length-1].v,adeqC[adeqC.length-1].v,1);
  const W=880,H=200,PL=70,PR=20,PT=20,PB=30;
  const cw=W-PL-PR,ch=H-PT-PB;
  const toX=y=>PL+(y/s.h)*cw,toY=v=>PT+ch-(v/maxC)*ch;
  const inadPath=inadC.map((p,i)=>`${i===0?'M':'L'}${toX(p.y).toFixed(1)},${toY(p.v).toFixed(1)}`).join(' ');
  const adeqPath=adeqC.map((p,i)=>`${i===0?'M':'L'}${toX(p.y).toFixed(1)},${toY(p.v).toFixed(1)}`).join(' ');
  const yTicks=[];for(let i=0;i<=4;i++){const val=(maxC/4)*i;yTicks.push({val,y:toY(val)})}
  const xLabels=inadC.filter((_,i)=>i%Math.max(1,Math.ceil(s.h/8))===0||i===inadC.length-1);
  const failPts=inadC.filter(p=>p.y>0&&p.y%s.dc===0&&p.y<s.h);

  const warnMsg=s.h<s.dc?`<div style="font-size:12px;color:var(--ot-amber);margin-top:8px;margin-bottom:4px">Período menor que a durabilidade do sistema padrão (${s.dc} anos). Aumente para comparar ciclos.</div>`:'';

  let h=`<p style="color:var(--ot-sub);font-size:15px;line-height:1.7;margin-bottom:20px">Calcule o Custo Total de Propriedade (TCO) e compare o Padrão do Mercado vs alta performance.</p>`;

  h+=`<div class="sec-label">${ICO.layers}<h3>Tipo de Aplicação</h3></div>`;
  h+=`<div class="chip-group mb-24" role="radiogroup">
    <button class="chip ${s.tipo==='metal'?'active':''}" data-tipo="metal">Metal Mecânica</button>
    <button class="chip ${s.tipo==='piso'?'active':''}" data-tipo="piso">Piso Industrial</button>
  </div>`;

  h+=`<div class="grid-2 mb-24">
    <div class="field"><label>Área (m²)</label><div class="field-wrap"><input type="number" data-roi="a" value="${s.a}" min="50" inputmode="numeric" class="has-unit"><span class="unit">m²</span></div></div>
    <div class="field"><label>Período de análise</label>${makeStepper('h',s.h,1,30,1,'anos')}</div>
    <div class="field"><label>R$/m² Padrão do Mercado</label><div class="field-wrap"><input type="number" data-roi="cc" value="${s.cc}" min="10" inputmode="numeric" class="has-unit"><span class="unit">R$/m²</span></div></div>
    <div class="field"><label>R$/m² alta performance</label><div class="field-wrap"><input type="number" data-roi="ca" value="${s.ca}" min="20" inputmode="numeric" class="has-unit"><span class="unit">R$/m²</span></div></div>
    <div class="field"><label>Durabilidade padrão</label>${makeStepper('dc',s.dc,1,25,1,'anos')}</div>
    <div class="field"><label>Durabilidade alta perf.</label>${makeStepper('da',s.da,5,25,1,'anos')}</div>
  </div>`;

  h+=`<button class="accordion-toggle ${s.advOpen?'open':''}" id="roiAdvToggle" type="button">${ICO.chevron} Configuração avançada</button>`;
  h+=`<div class="accordion-body ${s.advOpen?'open':''}" id="roiAdvBody">
    <div class="grid-2 mb-24" style="padding-top:8px">
      <div class="field"><label>Custo parada/dia</label><div class="field-wrap"><input type="number" data-roi="cp" value="${s.cp}" min="0" inputmode="numeric" class="has-unit"><span class="unit">R$</span></div></div>
      <div class="field"><label>Manutenção preventiva</label><div class="field-wrap"><input type="number" data-roi="cm" value="${s.cm}" min="0" inputmode="numeric" class="has-unit"><span class="unit">R$</span></div></div>
      <div class="field"><label>Prep. superfície adequada</label><div class="field-wrap"><input type="number" data-roi="prepA" value="${s.prepA}" min="5" inputmode="numeric" class="has-unit"><span class="unit">R$/m²</span></div></div>
      <div class="field"><label>Prep. superfície padrão</label><div class="field-wrap"><input type="number" data-roi="prepI" value="${s.prepI}" min="5" inputmode="numeric" class="has-unit"><span class="unit">R$/m²</span></div></div>
    </div>
  </div>`;

  h+=warnMsg;

  /* Chart SVG */
  h+=`<div class="bento mb-12" style="padding:20px 24px;margin-top:24px">
    <div style="display:flex;align-items:center;gap:8px;margin-bottom:16px">
      <span style="color:var(--ot-accent)">${ICO.trending}</span>
      <span style="font-size:14px;font-weight:600">Custo acumulado ao longo de ${s.h} anos</span>
    </div>
    <svg viewBox="0 0 ${W} ${H}" style="width:100%;height:auto" role="img">
      ${yTicks.map(t=>`<line x1="${PL}" y1="${t.y}" x2="${W-PR}" y2="${t.y}" stroke="rgba(23,23,23,.06)" stroke-width="1"/><text x="${PL-8}" y="${t.y+4}" fill="var(--ot-muted)" font-size="9" text-anchor="end" font-family="Inter,sans-serif">${fmtR(t.val)}</text>`).join('')}
      ${xLabels.map(p=>`<text x="${toX(p.y)}" y="${H-5}" fill="var(--ot-muted)" font-size="9" text-anchor="middle" font-family="Inter,sans-serif">${p.y===0?'Hoje':`${p.y}a`}</text>`).join('')}
      <path d="${inadPath} L${toX(s.h).toFixed(1)},${toY(0).toFixed(1)} L${toX(0).toFixed(1)},${toY(0).toFixed(1)} Z" fill="rgba(225,29,72,.08)" opacity=".5"/>
      <path d="${adeqPath} L${toX(s.h).toFixed(1)},${toY(0).toFixed(1)} L${toX(0).toFixed(1)},${toY(0).toFixed(1)} Z" fill="rgba(22,163,74,.08)" opacity=".5"/>
      <path d="${inadPath}" fill="none" stroke="#E11D48" stroke-width="2.5" stroke-linejoin="round"/>
      <path d="${adeqPath}" fill="none" stroke="#16A34A" stroke-width="2.5" stroke-linejoin="round"/>
      <circle cx="${toX(s.h)}" cy="${toY(inadC[inadC.length-1].v)}" r="4" fill="#E11D48"/>
      <circle cx="${toX(s.h)}" cy="${toY(adeqC[adeqC.length-1].v)}" r="4" fill="#16A34A"/>
      ${failPts.map(p=>`<circle cx="${toX(p.y)}" cy="${toY(p.v)}" r="5" fill="#fff" stroke="#E11D48" stroke-width="2"/><text x="${toX(p.y)}" y="${toY(p.v)-10}" fill="#E11D48" font-size="8" text-anchor="middle" font-weight="600" font-family="Inter,sans-serif">Repintura</text>`).join('')}
    </svg>
    <div style="display:flex;gap:20px;margin-top:12px;font-size:12px">
      <span style="display:flex;align-items:center;gap:6px;color:#E11D48"><span style="width:16px;height:3px;border-radius:2px;background:#E11D48;display:inline-block"></span>Padrão do Mercado (${rInad} repinturas)</span>
      <span style="display:flex;align-items:center;gap:6px;color:#16A34A"><span style="width:16px;height:3px;border-radius:2px;background:#16A34A;display:inline-block"></span>Alta Performance (${rAdeq} manutenções)</span>
    </div>
  </div>`;

  /* Cards */
  h+=`<div class="grid-3 mb-12">
    <div class="roi-card" style="border-top:3px solid #E11D48">
      <div class="stat-icon" style="color:#E11D48">${ICO.alert}</div>
      <div class="stat-label">Padrão do Mercado</div>
      <div class="stat-value" style="color:#E11D48;font-size:26px">${fmtR(tcoInad)}</div>
      <div class="stat-sub">${rInad} repinturas em ${s.h} anos</div>
      <div class="roi-bar"><div class="roi-bar-fill" style="width:100%;background:linear-gradient(90deg,#E11D48,rgba(225,29,72,.5))"></div></div>
    </div>
    <div class="roi-card" style="border-top:3px solid #16A34A">
      <div class="stat-icon" style="color:#16A34A">${ICO.shield}</div>
      <div class="stat-label">Alta Performance</div>
      <div class="stat-value" style="color:#16A34A;font-size:26px">${fmtR(tcoAdeq)}</div>
      <div class="stat-sub">${rAdeq} manutenções em ${s.h} anos</div>
      <div class="roi-bar"><div class="roi-bar-fill" style="width:${Math.min(100,(tcoAdeq/mx)*100)}%;background:linear-gradient(90deg,#16A34A,rgba(22,163,74,.5))"></div></div>
    </div>
    <div class="roi-card" style="border-top:3px solid var(--ot-accent);background:var(--ot-accent-soft)">
      <div class="stat-icon" style="color:var(--ot-accent)">${ICO.trending}</div>
      <div class="stat-label">Economia</div>
      <div class="stat-value" style="color:var(--ot-accent);font-size:26px">${fmtR(eco)}</div>
      <div class="stat-sub">ROI de ${roiPct.toFixed(0)}%</div>
      <div class="roi-bar" style="background:rgba(11,97,205,.08)"><div class="roi-bar-fill" style="width:${Math.min(100,Math.max(5,(eco/mx)*100))}%;background:linear-gradient(90deg,var(--ot-accent),rgba(11,97,205,.5))"></div></div>
    </div>
  </div>`;

  /* Investir no Sistema */
  h+=`<div class="sec-label mb-16 mt-24">${ICO.shield}<h2>Investir no Sistema Adequado</h2></div>`;
  const rec=s.tipo==='metal'?['TMER','TPUR']:['EXA','ECR'];
  const recRals=rec.reduce((acc, linha) => {
    const lr = getRals(linha);
    return acc ? acc.filter(r => lr.includes(r)) : [...lr];
  }, null) || RAL_FULL;
  h+=`<p style="color:var(--ot-sub);font-size:14px;margin-bottom:16px">Selecione a cor para visualizar produtos recomendados para ${s.tipo==='metal'?'proteção de metal':'piso industrial'}.</p>`;

  if(!roiState.ral){
    h+=`<div class="ral-search">`;
    h+=`<div class="ral-cat-bar">`;
    RAL_CATS.forEach(cat=>{
      h+=`<button class="ral-cat-chip" data-roi-cat="${cat.prefix}"><span style="width:12px;height:12px;background:${cat.cor};border-radius:3px;display:inline-block;flex-shrink:0"></span> ${cat.label}</button>`;
    });
    h+=`<button class="ral-cat-chip" data-roi-cat="all">Todas</button>`;
    h+=`</div>`;
    h+=`<div class="ral-search-wrap"><span class="ral-search-icon">${ICO.search}</span>`;
    h+=`<input type="text" class="ral-search-input" id="roiRalInput" placeholder="Buscar RAL (ex: 7035, cinza, grey...)" autocomplete="off"></div>`;
    h+=`<div class="ral-results" id="roiRalList"></div></div>`;
  }else if(roiState.roiProducts.length>0){
    h+=`<div class="ral-selected">${ralSwatch(roiState.ral,20)}<span>RAL ${roiState.ral} ${ralName(roiState.ral)}</span><button class="ral-clear" id="roiClearRal">Trocar</button></div>`;

    h+=`<div class="sec-label mb-16 mt-24">${ICO.bucket}<h3>Volume da Lata</h3></div>`;
    h+=`<div class="seg mb-24" role="radiogroup">`;
    ['3.6L','18L'].forEach(v=>{
      h+=`<button class="${roiState.roiVol===v?'active':''}" data-roi-vol="${v}">${v}</button>`;
    });
    h+=`</div>`;

    h+=`<div class="sec-label mb-16">${ICO.layers}<h3>Produtos Recomendados</h3></div>`;
    h+=`<div style="display:flex;flex-direction:column;gap:12px;margin-bottom:24px">`;
    roiState.roiProducts.forEach((prod,pi)=>{
      const l=LINHAS[prod.linha];
      const variant=findVariant(prod.product,roiState.roiVol);
      const price=variant?variant.price/100:0;
      const vid=variant?variant.id:null;
      const fbk=roiState.roiCartFbk['roi-'+pi];

      h+=`<div class="prod-preview">`;
      h+=`<img src="${getProductImage(prod.product)}" alt="${prod.product.title}" loading="lazy">`;
      h+=`<div class="prod-info"><div class="prod-name">${prod.product.title}</div><div class="prod-meta">${l.base} | ${l.nome}</div></div>`;
      h+=`<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">`;
      h+=`<div class="prod-price">${fmt(price)}</div>`;
      if(fbk) h+=`<span class="cart-ok">${ICO.check} Adicionado</span>`;
      else if(vid) h+=`<button class="ot-btn-outline" data-roi-cart-add="${vid}" data-roi-cart-key="roi-${pi}">${ICO.cart} Adicionar</button>`;
      h+=`</div></div>`;
    });
    h+=`</div>`;
  }else if(roiState.ral){
    h+=`<div style="text-align:center;padding:32px 0"><span class="spinner"></span></div>`;
  }

  h+=makeFontes(['ABRACO: custos de corrosão no Brasil','Boletins Técnicos Eurolatina','Abrafati: dados de durabilidade']);
  h+=`<p class="disclaimer" style="margin-top:12px">Fórmula TCO: Ci + Cp + Ca + Cm + Cr + Cpi.</p>`;

  container.innerHTML=h;
  applyOtSwatchColors(container);

  /* Events */
  $$('.chip[data-tipo]',container).forEach(c=>c.addEventListener('click',()=>{
    if(c.dataset.tipo==='metal')Object.assign(roiState,{tipo:'metal',a:500,h:15,cc:70,ca:180,dc:3,da:15,cp:50000,cm:18000,prepA:40,prepI:10,ral:'',roiProducts:[],roiVol:'18L',roiCartFbk:{}});
    else Object.assign(roiState,{tipo:'piso',a:2000,h:20,cc:55,ca:175,dc:5,da:20,cp:80000,cm:60000,prepA:45,prepI:15,ral:'',roiProducts:[],roiVol:'18L',roiCartFbk:{}});
    renderShell();
  }));
  $$('input[data-roi]',container).forEach(inp=>{
    inp.addEventListener('change',()=>{if(validateInput(inp)){roiState[inp.dataset.roi]=Math.max(+inp.min||0,+inp.value);renderShell();}});
  });
  $$('.stepper .stepper-btn',container).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const st=btn.closest('.stepper');
      const k=st.dataset.k,mn=+st.dataset.min,mx2=+st.dataset.max,step=+st.dataset.step,dir=+btn.dataset.dir;
      roiState[k]=clamp(roiState[k]+dir*step,mn,mx2);
      renderShell();
    });
  });
  const togBtn=$('#roiAdvToggle',container);
  if(togBtn){
    togBtn.addEventListener('click',()=>{
      roiState.advOpen=!roiState.advOpen;
      togBtn.classList.toggle('open',roiState.advOpen);
      const body=$('#roiAdvBody',container);
      if(body) body.classList.toggle('open',roiState.advOpen);
    });
  }
  bindROICartEvents(container);
}

/* ═══════════════════════════════════════════════════════════
   TAB 5: PISO INDUSTRIAL
   ═══════════════════════════════════════════════════════════ */
const pisoState={comp:20,larg:15,t:'eurocoat',trafego:'moderado',pisoVol:'18L',layers:{}};

/* Events for Piso cart integration */
async function bindPisoCartEvents(ctx){
  const sys=PISO_SYS[pisoState.t];

  /* Per-layer RAL input handlers */
  $$('[data-piso-ral-input]',ctx).forEach(inp=>{
    const layerIdx=+inp.dataset.pisoRalInput;
    const cm=sys.cam[layerIdx];
    const list=$(`[data-piso-ral-list="${layerIdx}"]`,ctx);
    const rals=getRals(cm.linha);
    let activeCat=null;

    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      if(matches.length===0){
        list.innerHTML='<div class="ral-no-results">Nenhum código encontrado</div>';
        return;
      }
      list.innerHTML=matches.map(r=>{
        return `<div class="ral-item" data-piso-ral-pick="${r}">${ralSwatch(r,18)}<span>RAL ${r} <span class="ral-name-hint">${ralName(r)}</span></span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,cm.linha,matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectPisoLayerRal(layerIdx,cm.linha,item.dataset.pisoRalPick));
      });
    };

    inp.addEventListener('input',()=>showResults(inp.value.trim().toLowerCase()));
    inp.addEventListener('focus',()=>showResults(inp.value.trim().toLowerCase()));
  });

  /* Per-layer category chips */
  $$('[data-piso-cat]',ctx).forEach(chip=>{
    const layerIdx=+chip.dataset.pisoLayer;
    const cm=sys.cam[layerIdx];
    const inp=$(`[data-piso-ral-input="${layerIdx}"]`,ctx);
    const list=$(`[data-piso-ral-list="${layerIdx}"]`,ctx);
    const rals=getRals(cm.linha);
    let activeCat=null;

    const showResults=(q)=>{
      let pool=rals;
      if(activeCat && activeCat!=='all') pool=rals.filter(r=>r.startsWith(activeCat));
      let matches;
      if(!q){matches=pool;}
      else{
        const ql=q.toLowerCase();
        matches=pool.filter(r=>{
          if(r.includes(ql)) return true;
          const name=ralName(r);
          if(name&&name.toLowerCase().includes(ql)) return true;
          return false;
        });
      }
      list.innerHTML=matches.length===0?'<div class="ral-no-results">Nenhum código encontrado</div>':matches.map(r=>{
        return `<div class="ral-item" data-piso-ral-pick="${r}">${ralSwatch(r,18)}<span>RAL ${r} <span class="ral-name-hint">${ralName(r)}</span></span></div>`;
      }).join('');
      applyOtSwatchColors(list);
      loadRalItemImages(list,cm.linha,matches);
      $$('.ral-item',list).forEach(item=>{
        item.addEventListener('click',()=>selectPisoLayerRal(layerIdx,cm.linha,item.dataset.pisoRalPick));
      });
    };

    chip.addEventListener('click',()=>{
      activeCat=chip.dataset.pisoCat==='all'?null:chip.dataset.pisoCat;
      $$(`[data-piso-layer="${layerIdx}"]`,ctx).forEach(c=>c.classList.remove('active'));
      chip.classList.add('active');
      showResults(inp.value.trim().toLowerCase());
    });
  });

  /* Clear RAL per-layer */
  $$('[data-piso-clear]',ctx).forEach(btn=>{
    const layerIdx=+btn.dataset.pisoClear;
    btn.addEventListener('click',()=>{
      pisoState.layers[layerIdx]={};
      renderShell();
    });
  });

  /* Volume selector */
  $$('[data-piso-vol]',ctx).forEach(btn=>{
    btn.addEventListener('click',()=>{
      pisoState.pisoVol=btn.dataset.pisoVol;
      renderShell();
    });
  });

  /* Per-layer cart buttons */
  $$('[data-piso-cart-add]',ctx).forEach(btn=>{
    btn.addEventListener('click',async()=>{
      btn.disabled=true;btn.innerHTML='<span class="spinner"></span>';
      const ok=await addToCart(btn.dataset.pisoCartAdd,+btn.dataset.pisoCartQty);
      if(ok){pisoState.layers[+btn.dataset.pisoCartKey].fbk=true;refreshCartUI();renderShell();}
      else{btn.innerHTML='Erro';btn.disabled=false;}
    });
  });
}

/* RAL selection for Piso per-layer */
async function selectPisoLayerRal(layerIdx,linha,ral){
  if(!pisoState.layers[layerIdx]) pisoState.layers[layerIdx]={};
  pisoState.layers[layerIdx].ral=ral;
  pisoState.layers[layerIdx].product=null;
  pisoState.layers[layerIdx].fbk=false;
  pisoState.layers[layerIdx].error=false;
  renderShell();

  const handle=getHandle(linha,ral);
  if(!handle){pisoState.layers[layerIdx].error=true;renderShell();return;}
  const product=await fetchProduct(handle);
  if(product){
    pisoState.layers[layerIdx].product=product;
  }else{
    pisoState.layers[layerIdx].error=true;
  }
  renderShell();
}

const trafData={
  leve:{desc:'Armazéns leves, garagens'},
  moderado:{desc:'Logística, centros distribuição'},
  pesado:{desc:'Ind. alimentícia, farmacêutica'},
  severo:{desc:'Química pesada, metalurgia'}
};
const PISO_SPECS={
  eurocoat:{
    espessura:'~250 μm',espDetail:'Primer 50μm + Eurocoat 100μm x2',
    vida:{leve:'8-12 anos',moderado:'6-10 anos',pesado:'4-7 anos',severo:'3-5 anos'}
  },
  exapiso:{
    espessura:'~200 μm',espDetail:'Primer 50μm + Exapiso 150μm',
    vida:{leve:'6-10 anos',moderado:'5-8 anos',pesado:'3-6 anos',severo:'2-4 anos'}
  },
  pu:{
    espessura:'~310 μm',espDetail:'Primer 50μm + Eurocoat 100μm x2 + PU 60μm',
    vida:{leve:'12-18 anos',moderado:'10-15 anos',pesado:'7-12 anos',severo:'5-8 anos'}
  }
};
const PISO_SYS={
  eurocoat:{nm:'Exaprimer + Eurocoat',cam:[
    {n:'Exaprimer (Primer)',r:6,d:1,nt:'4-8 m²/L',linha:'EXA'},
    {n:'Eurocoat (ECR)',r:5,d:2,nt:'5 m²/L @100μm',linha:'ECR'}
  ]},
  exapiso:{nm:'Exaprimer + Exapiso',cam:[
    {n:'Exaprimer (Primer)',r:6,d:1,nt:'4-8 m²/L',linha:'EXA'},
    {n:'Exapiso (EXAR)',r:8,d:1,nt:'8 m²/L @150μm',linha:'EXAR'}
  ]},
  pu:{nm:'Exaprimer + Eurocoat + Top Coat PU',cam:[
    {n:'Exaprimer (Primer)',r:6,d:1,nt:'4-8 m²/L',linha:'EXA'},
    {n:'Eurocoat (ECR)',r:5,d:2,nt:'5 m²/L @100μm',linha:'ECR'},
    {n:'Top Coat PU (TCPR)',r:10,d:1,nt:'10 m²/L @60μm',linha:'TCPR'}
  ]}
};

function renderPiso(container){
  const s=pisoState;
  const a=s.comp*s.larg;
  const sys=PISO_SYS[s.t];
  const tf=trafData[s.trafego];
  const pSpec=PISO_SPECS[s.t];

  let h=`<p style="color:var(--ot-sub);font-size:15px;line-height:1.7;margin-bottom:28px">Calcule o consumo para piso industrial. Dados dos Boletins Técnicos Eurolatina.</p>`;

  h+=`<div class="grid-2 mb-24">
    <div class="field"><label>Comprimento</label><div class="field-wrap"><input type="number" data-piso="comp" value="${s.comp}" min="1" inputmode="numeric" class="has-unit"><span class="unit">m</span></div></div>
    <div class="field"><label>Largura</label><div class="field-wrap"><input type="number" data-piso="larg" value="${s.larg}" min="1" inputmode="numeric" class="has-unit"><span class="unit">m</span></div></div>
  </div>`;

  h+=`<div class="sec-label">${ICO.layers}<h3>Sistema</h3></div>`;
  h+=`<div class="chip-group mb-24" role="radiogroup">`;
  [['eurocoat','Eurocoat'],['exapiso','Exapiso'],['pu','Epóxi + PU']].forEach(([k,v])=>{
    h+=`<button class="chip ${s.t===k?'active':''}" data-sys="${k}">${v}</button>`;
  });
  h+=`</div>`;

  h+=`<div class="sec-label">${ICO.shield}<h3>Tipo de Tráfego</h3></div>`;
  h+=`<div class="chip-group mb-24" role="radiogroup">`;
  Object.keys(trafData).forEach(k=>{
    h+=`<button class="chip ${s.trafego===k?'active':''}" data-traf="${k}">${k.charAt(0).toUpperCase()+k.slice(1)}</button>`;
  });
  h+=`</div>`;

  h+=`<div class="grid-3 mb-16">
    ${makeStat('Área Total',`${a.toLocaleString('pt-BR')} m²`,'var(--ot-accent)',ICO.area)}
    ${makeStat('Espessura do Sistema',pSpec.espessura,'#16A34A',ICO.layers,pSpec.espDetail)}
    ${makeStat('Vida Útil Esperada',pSpec.vida[s.trafego],'var(--ot-text)',ICO.gauge,`${tf.desc} | Tráfego ${s.trafego}`)}
  </div>`;

  /* Volume selector */
  h+=`<div class="sec-label mb-16">${ICO.bucket}<h3>Volume da Lata</h3></div>`;
  h+=`<div class="seg mb-24" role="radiogroup">`;
  ['3.6L','18L'].forEach(v=>{
    h+=`<button class="${s.pisoVol===v?'active':''}" data-piso-vol="${v}">${v}</button>`;
  });
  h+=`</div>`;

  h+=`<div class="bento mb-12">`;
  h+=`<div class="sec-label">${ICO.layers}<h3>${sys.nm}</h3></div>`;
  h+=`<div style="display:flex;flex-direction:column;gap:16px;margin-top:12px">`;
  sys.cam.forEach((cm,ci)=>{
    const cons=cm.r?(a/cm.r)*cm.d*1.15:null;
    const ld=s.layers[ci]||{};
    const rals=getRals(cm.linha);

    h+=`<div class="bento mb-12">`;
    h+=`<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:12px">`;
    h+=`<div><div style="font-weight:600;font-size:15px">${cm.n}</div><div style="color:var(--ot-sub);font-size:12px;margin-top:2px">${cm.nt}</div></div>`;
    if(cons) h+=`<div style="text-align:right"><div class="piso-val">${cons.toFixed(0)} L</div><div class="piso-sub">${Math.ceil(cons/18)} lata(s) 18L</div></div>`;
    else h+=`<div style="color:var(--ot-amber);font-size:13px;font-weight:600">Consulte BT</div>`;
    h+=`</div>`;

    if(!ld.ral){
      h+=`<div class="ral-search">`;
      const hasCategories=!LINHAS[cm.linha].ralLabels && rals.length>20;
      if(hasCategories){
        h+=`<div class="ral-cat-bar">`;
        RAL_CATS.forEach(cat=>{
          const catRals=rals.filter(r=>r.startsWith(cat.prefix));
          if(catRals.length>0) h+=`<button class="ral-cat-chip" data-piso-cat="${cat.prefix}" data-piso-layer="${ci}"><span style="width:12px;height:12px;background:${cat.cor};border-radius:3px;display:inline-block;flex-shrink:0"></span> ${cat.label}</button>`;
        });
        h+=`<button class="ral-cat-chip" data-piso-cat="all" data-piso-layer="${ci}">Todas</button>`;
        h+=`</div>`;
      }
      const l=LINHAS[cm.linha];
      h+=`<div class="ral-search-wrap"><span class="ral-search-icon">${ICO.search}</span>`;
      h+=`<input type="text" class="ral-search-input" data-piso-ral-input="${ci}" placeholder="${l.ralLabels?'Selecione a cor':'Buscar RAL'}" autocomplete="off"></div>`;
      h+=`<div class="ral-results" data-piso-ral-list="${ci}"></div>`;
      h+=`</div>`;
    } else {
      const l=LINHAS[cm.linha];
      const label=l.ralLabels?l.ralLabels[ld.ral]:'RAL '+ld.ral;
      const name=l.ralLabels?'':(' '+ralName(ld.ral));
      h+=`<div class="ral-selected">${ralSwatch(ld.ral,20)}<span>${label}${name}</span><button class="ral-clear" data-piso-clear="${ci}">Trocar</button></div>`;

      if(ld.product){
        const variant=findVariant(ld.product,s.pisoVol);
        const price=variant?variant.price/100:0;
        const lataCap=s.pisoVol==='18L'?18:3.6;
        const qty=cons?Math.ceil(cons/lataCap):1;
        const subtotal=price*qty;
        const vid=variant?variant.id:null;

        h+=`<div class="prod-preview">`;
        h+=`<img src="${getProductImage(ld.product)}" alt="${ld.product.title}" loading="lazy">`;
        h+=`<div class="prod-info"><div class="prod-name">${ld.product.title}</div><div class="prod-meta">${qty}x ${s.pisoVol} | ${fmt(price)}/un</div></div>`;
        h+=`<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">`;
        h+=`<div class="prod-price">${fmt(subtotal)}</div>`;
        if(ld.fbk) h+=`<span class="cart-ok">${ICO.check} Adicionado</span>`;
        else if(vid) h+=`<button class="ot-btn-outline" data-piso-cart-add="${vid}" data-piso-cart-qty="${qty}" data-piso-cart-key="${ci}">${ICO.cart} Adicionar</button>`;
        h+=`</div></div>`;
      } else if(ld.error) {
        h+=`<div style="padding:12px;color:var(--ot-amber);font-size:13px;font-weight:500;background:var(--ot-amberSoft);border-radius:8px;text-align:center">Produto indisponível para esta cor. Selecione outra.</div>`;
      } else {
        h+=`<div style="text-align:center;padding:16px 0"><span class="spinner"></span></div>`;
      }
    }
    h+=`</div>`;
  });
  h+=`</div></div>`;

  h+=`<div class="info-box" style="background:rgba(22,163,74,.06)">
    <span style="font-size:14px;color:#16A34A;line-height:1.7">Preparação do substrato é o fator mais crítico. Fresagem diamantada resulta em durabilidade 4-5x maior vs lixamento manual.</span>
  </div>`;

  h+=makeFontes(['Boletins Técnicos Eurolatina','ABRACO: dados de preparação de superfície','Abrafati: referências de pisos']);
  h+=makeDisclaimer();

  container.innerHTML=h;
  applyOtSwatchColors(container);

  $$('input[data-piso]',container).forEach(inp=>{
    inp.addEventListener('change',()=>{if(validateInput(inp)){pisoState[inp.dataset.piso]=Math.max(1,+inp.value);renderShell();}});
  });
  $$('.chip[data-sys]',container).forEach(c=>c.addEventListener('click',()=>{pisoState.t=c.dataset.sys;pisoState.layers={};renderShell();}));
  $$('.chip[data-traf]',container).forEach(c=>c.addEventListener('click',()=>{pisoState.trafego=c.dataset.traf;renderShell();}));
  bindPisoCartEvents(container);
}

/* ─── INIT ─── */
document.addEventListener('DOMContentLoaded',()=>renderShell());

})();
